import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  OnChanges,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { catchError, filter, map, take, takeUntil } from 'rxjs';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormioCustomComponent, FormioEvent } from '@app/shared/elements.common';
import { AlertService } from '@app/@core/services/alert.service';
import { FormioComponent } from '@formio/angular';
import { FormioService } from '@pics-core/dynamic';
import { DxDataGridComponent } from 'devextreme-angular';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { now } from 'moment';
import { AuthService } from '@pics-core/dynamic';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PageBuilderAddService } from '@app/pages/page-designer/@core/page-builder-add.service';
import { HttpService } from '@app/@core/services/http.service';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { AuthService as AppAuthService } from '@app/@core/services/auth.service';
import { LocalService } from '@app/@core/services/local.service';
import { doesNotQualify, intake } from '@app/shared/directives/queue-status-filter.constant';
import { ROLE_ID } from '@app/shared/constants/rolesConstant.model';
// import { DOCUMENT_PAGE_CONSTANT } from './constants/document-page.constant';

interface FileUpload {
  fileName: string;
  contentType: string;
  type: string;
}

interface FileUploadInfo {
  type: string;
  formid: number;
  attachmentdetails: Array<{ name: string; path: string; attachmenttype: string }>;
}


@Component({
  standalone: false,
  selector: 'app-document-upload-grid',
  templateUrl: './document-upload-grid.component.html',
  styleUrls: ['./document-upload-grid.component.scss']
})
export class DocumentUploadGridComponent implements OnInit, OnChanges, FormioCustomComponent<any> {
  @Input()
  formId: string;

  @Input()
  gridId: string;

  @Input()
  query: any;

  @Input()
  fields: any;

  @Input()
  buttonLabel: any;

  @Input()
  value: any;

  @Output()
  valueChange: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  disabled: boolean;

  @Input()
  disableAdd: string;

  @Input()
  name: string;

  @Input()
  showArchived: boolean;

  @Input()
  readOnlyCondition: string = '';

  @Output()
  formioEvent: EventEmitter<FormioEvent> = new EventEmitter<FormioEvent>();

  @ViewChild('formModal') formModal: ElementRef;

  @ViewChild('formIO', { static: false })
  formIO: FormioComponent;

  @ViewChild('duplicateApplicantModel', { static: false })
  duplicateApplicantModelTemplate: TemplateRef<any>;

  @ViewChild('duplicateStaffModel', { static: false })
  duplicateStaffModelTemplate: TemplateRef<any>;

  @ViewChild('deleteModel', { static: false })
  deleteModelTemplate: TemplateRef<any>;

  @ViewChild('replaceModel', { static: false })
  replaceModelTemplate: TemplateRef<any>;

  @ViewChild('uploadModel', { static: false })
  uploadModel: TemplateRef<any>;
  @ViewChild('viewModel', { static: false })
  viewModel: TemplateRef<any>;

  @ViewChild('confirmCancelModel', { static: false })
  confirmCancelModel: TemplateRef<any>;

  @ViewChild('confirmValidModel', { static: false })
  confirmValidModel: TemplateRef<any>;
  gridItems: any[] = [];
  gridConfig: any;

  private formData: any = {};
  private lastFormioChange: any = null;

  private BINDING_REGEX = /{\{([0-9A-Za-z_\.\s]+)\}\}/g;

  private bindings = [];

  formJson: any = {};

  modalref: NgbModalRef;
  duplicateModalRef: NgbModalRef | null = null;
  uploadModalRef: NgbModalRef | null = null;
  confirmCancelModalRef: NgbModalRef | null = null;
  private skipUploadDismissGuard = false;
  private uploadModalInitialState: { category: string; docType: string; hasFile: boolean } | null = null;

  updateGrid: any;

  isView: boolean;

  customData: any = {};

  primaryColumn: string;

  deleteId: any;

  formName: string;

  isVisible = true;

  isDisable = false;

  formStatus: string;
  selectedCategory: any;
  selectedDocType: any;
  private _formattedName: string;
  documentHistory = [];
  archivedDocumentHistory: any[] = [];
  archivedTabEnabled = false;
  uploadDocumentHistory: any[] = [];
  activeDocumentTab: 'upload' | 'archived' = 'upload';
  pageList: any;
  tableColumns: any[] = [];
  //updateGrid: any;
  totalcount = 0;
  //gridId: string;
  filterOptions: any[] = [];
  gridOptions: { value: string; label: string; code: string }[] = [];
  gridColumns: any[] = [];
  uploadedFiles: any[] = [];
  selectedDocuments: any[] = [];
  isDownloading = false;
  categories: any[] = [];
  documentTypes: any[] = [];
  filteredDocumentTypes: any[] = [];


  loginUserId: number;
  loginUserRoleId: number;
  isShowMarkAsValid: boolean = false;
  isShowReplaceFile: boolean = false;
  isShowMarkAsDificient: boolean = false;
  isShowView: boolean = false;
  isShowDownload: boolean = false;
  isShowDelete: boolean = false;
  applicationStatus: string;
  dnqUploadAllowed: boolean = true;
  dnqUploadMessage: string = '';
  private dnqUploadDeadline: Date | null = null;
  private dnqUploadChecked = false;
  private dnqUploadPersonId: any = null;
  allowedTypes: null | string = null;
  maxFileSize: null | number = null;
  showAction: boolean = true;
  needDragAndDrop: boolean = false;
  fileUploadError: string = '';
  readonly fileTypeNotSupportedMessage: string = 'The selected file type is not supported.';
  readonly fileSizeExceededMessage: string = 'The selected file exceeds the maximum allowed size of 15 MB.';
  private readonly maxUploadFileSizeBytes = 15728640; // 15 MB
  sharedInfo: any = {};
  pageId: any;
  responseId: any;
  uploadedFilesTest: any = [];
  isShow: boolean;
  isReplaceFlow: boolean = false;
  readOnlyMode: boolean = false;


  // Categories that do not require a document type selection
  private readonly optionalDocTypeCategories: string[] = [
    'ARL Certificate',
    'Apprentice Letter',
    'Nevada Testing Score Report',
    'Out-of-State Testing Score Report',
    'History Disclosure Documentation',
    'Out-of-State or Country Licensure',
    'District / Charter School Name',
    'Provider Name'
  ];
  private readonly EDU_CAT_ARL = 'ARL Program Evaluation';
  private readonly EDU_CAT_PROOF = 'Proof of Program Completion';
  private readonly EDU_GRID_TYPE_NEVADA = 'nevadaTesting';
  private readonly EDU_GRID_TYPE_OUT_OF_STATE = 'outOfStateTesting';
  private programProviderLookup: any[] = [];
  private applicationProviderCode: string = '';
  // Default categories on Personal-Info-Details-Page (photo ID always, others controlled by radios)
  private readonly defaultRowCategories: string[] = [
    'Proof of Photo Identification',
    'Proof of Legal Name Change',
    'Proof of Relationship',
    'Proof of Service'
  ];
  // Prevent refetching the same history when nothing has changed
  private lastHistoryKey: string | null = null;
  // Minimal built-in values so the dropdowns never render empty if the API shape changes
  private readonly fallbackCategories: any[] = [
    { key: 'Proof of Legal Name Change', value: 'Proof of Legal Name Change' },
    { key: 'Proof of Photo Identification', value: 'Proof of Photo Identification' },
    { key: 'Proof of Relationship', value: 'Proof of Relationship' },
    { key: 'Proof of Service', value: 'Proof of Service' }
  ];
  private readonly fallbackDocTypes: any[] = [
    { key: 'Driver\'s License', value: 'Driver\'s License' },
    { key: 'Passport', value: 'Passport' },
    { key: 'State-Issued Identification Card', value: 'State-Issued Identification Card' },
    { key: 'Adoption Decree', value: 'Adoption Decree' },
    { key: 'Court Order for Name Change', value: 'Court Order for Name Change' },
    { key: 'Divorce Decree', value: 'Divorce Decree' },
    { key: 'Marriage Certificate', value: 'Marriage Certificate' },
    { key: 'Naturalization Certificate', value: 'Naturalization Certificate' },
    { key: 'Other Legal Name Change Document', value: 'Other Legal Name Change Document' },
    { key: 'Military ID Card', value: 'Military ID Card' },
    { key: 'DD Form 214', value: 'DD Form 214' }
  ];
  displayMode = 'compact';
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid!: DxDataGridComponent;
  private subscription: Subscription = new Subscription();



  destroy$ = new Subject<void>();
  assessmentType: any;

  selectedDocForAction: any = null;
  deficiencyReason: string = '';
  deficiencyError: string = '';
  deficiencyNotesView: string = '';
  replaceUploadData: any = null;
  replaceUploadError: string = '';
  replaceUploadSuccess: string = '';
  pendingFileForUpload: any = null;
  previewDoc: any = null;
  previewUrl: SafeResourceUrl | null = null;
  pendingDuplicateUpload: {
    attachments: any[];
    resolvedCategory: string;
    resolvedDocType: string;
    isNewRow: boolean;
  } | null = null;
  private readonly applicantDuplicateRoleIds = new Set<number>([
    ROLE_ID.NDE_Applicant,
    405
  ]);
  private readonly wizardNavigationClassPattern = /(btn-wizard-nav-next|btn-wizard-nav-submit|formio-button-next|formio-button-submit)/i;
  private readonly wizardSubmitClassPattern = /(btn-wizard-nav-submit|formio-button-submit)/i;
  private readonly documentClickHandler = (event: Event) => this.onDocumentClick(event);
  private readonly backofficePendingFallbackKey = '17';
  private nextButtonStateSyncTimers: number[] = [];
  private isDocumentClickHandlerAttached = false;
  private isNameChangeResubmitStatusUpdateInProgress = false;
  private backofficePendingStatusKey: string | null = null;

  // When uploading for a specific row, this holds that row reference
  selectedRowForUpload: any = null;

  @Input()
  id: number | null = null;

  @Input()
  needsLegalNameChange: boolean = false;
  legalNameChangeRecordCount = 0;

  @Input()
  isOnActiveDuty: boolean = false;

  isVeteranDefinition: boolean = false;

  isSpouseOnActiveDuty: boolean = false;

  isSpouseVeteran: boolean = false;
  private manualActiveDutySet = false;
  private manualVeteranDefinitionSet = false;
  private manualSpouseActiveDutySet = false;
  private manualSpouseVeteranSet = false;

  // Professional-Development page state tracking
  // These store raw values (can be null/undefined) for validation purposes
  private rawDistrictCharterEmployed: boolean | null = null;
  private rawAdditionalProfCompleted: boolean | null = null;
  private rawCollegeUnivCoursework: boolean | null = null;
  private rawCollegeUnivCreditsEarned: any = null;
  // These are resolved booleans for row display logic
  isDistrictCharterEmployed: boolean = false;
  isAdditionalProfCompleted: boolean = false;
  isCollegeUnivCoursework: boolean = false;
  collegeUnivSemCreditsEarned: any = null;
  private manualDistrictCharterSet = false;
  private manualAdditionalProfSet = false;
  private manualCollegeUnivCourseworkSet = false;
  private manualCollegeUnivCreditsSet = false;
  private profDevFormFieldsLoaded = false;
  // Store grid data arrays for dynamic row creation
  private districtGridData: any[] = [];
  private addProfDevelopmentData: any[] = [];

  private rawNevadaTestingEnabled: boolean | null = null;
  private rawOutOfStateTestingEnabled: boolean | null = null;
  private manualNevadaTestingSet = false;
  private manualOutOfStateTestingSet = false;
  isNevadaTestingEnabled: boolean = false;
  isOutOfStateTestingEnabled: boolean = false;
  private nevadaTestingGridData: any[] = [];
  private outOfStateTestingGridData: any[] = [];
  private eduFormFieldsLoaded = false;
  private eduSyncInProgress = false;
  private docTypesCacheVersion = 0;
  private docTypesCache = new Map<string, { version: number; result: any[] }>();
  // Track dynamically-added category keys so they can be cleaned up when grid items are removed
  private dynamicDistrictCategoryKeys = new Set<string>();
  private dynamicProviderCategoryKeys = new Set<string>();

  uploadData: any = {
    file: null,
    category: '',
    docType: ''
  };

  // categories = [
  //   { id: 4680, name: 'Proof of Photo Identification' },
  //   { id: 4681, name: 'Proof of Legal Name Change' },
  //   { id: 4682, name: 'Proof of Service' }
  // ];

  // documentTypes = [
  //   { id: 'pdf', name: 'PDF' },
  //   { id: 'doc', name: 'Word' },
  //   { id: 'img', name: 'Image' }
  // ];

  uploadForm: FormGroup;
  oneFileIsRequiredError: string;
  oneFileIsRequired: boolean;
  categoryError: string;
  docTypeError: string;
  duplicateDocTypeError: string;
  // Track which page this component instance was created for to prevent stale instances
  // from disabling navigation buttons after the user has navigated to a different page.
  private initialSessionTitle: string = '';
  constructor(
    private readonly pageBuilderService: PageBuilderAddService,
    private readonly formIoService: FormioService,
    private authService: AuthService,
    private pageBuilderAddService: PageBuilderAddService,
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly alertService: AlertService,
    private authServices: AuthService,
    private http: HttpClient,
    private readonly appAuthService: AppAuthService,
    private readonly httpService: HttpService,
    private readonly myAppService: MyApplicationsService,
    private readonly fb: FormBuilder,
    private readonly sanitizer: DomSanitizer,
    private readonly sessionStorage: LocalService
  ) {
    // For es lint
    this.formStatus = 'FORM_RESPONSE_ATTACHMENTS_';
    this.uploadForm = this.fb.group({
      category: ['', Validators.required],
      docType: ['', Validators.required],
      file: [null]
    });
    this.duplicateDocTypeError = '';
    this.sessionStorage.setObj('FileConfig', {
      allowedTypes: '.pdf,.jpg,.jpeg,.png',
      maxFileSize: this.maxUploadFileSizeBytes,
      needDragAndDrop: true,
      showAction: false
    })
  }


  getAllAttachments(pageId, responseId) {
    if (responseId) {
      this.formStatus = `${this.formStatus}UPDATE`;
    } else {
      this.formStatus = `${this.formStatus}CREATE`;
      this.cdr.detectChanges();
    }
    this.pageBuilderService.getFormResponseAttachment(pageId, responseId).pipe(
      filter((res: any) => !!res?.data?.length),
      map((res: any) => res.data),
    ).subscribe((data: any) => {
      const filterData = data
        .filter(item => item.path.includes(this._formattedName))
        .map((f) => ({
          ...f,
          field: this._formattedName,
        }));
      if (!filterData?.length) {
        return;
      }
      const fileInfo = {
        type: this.formStatus,
        formid: Number(pageId),
        attachmentdetails: filterData,
        field: this._formattedName,
        id: responseId,
        pageId: pageId
      };
      // (this.uploadedFiles || []).forEach((f) => {
      //   const isExist = filterData.find((file) => file.name === f.name && file.path === f.path);
      //   if (!isExist) {
      //     filterData.push(f);
      //   }
      // });
      const mapped = filterData.map(f => ({
        name: f.name,
        path: f.path,
        attachmenttype: f.attachmenttype,
        id: f.id,
        field: this._formattedName,
      }));
      //   this.value = this.uploadedFiles.map((f) => f.name).join(',');
      this.value = mapped;
      this.valueChange.emit(this.value);
      this.formioEvent.emit({ eventName: 'customEvent', data: { value: { fileInfo }, type: 'fileUpload', name: this._formattedName } });
      this.onFileUploaded(fileInfo)
      this.cdr.detectChanges();
    });
  }


  ngOnInit(): void {
    this.initialSessionTitle = this.getSessionTitle();
    if (this.name) {
      this._formattedName = this.name.replace(/data\[(.+)\]/, '$1');
    }
    const fileConfig = this.sessionStorage.getObj('FileConfig');
    if (fileConfig) {
      this.maxFileSize = fileConfig?.maxFileSize ?? this.maxFileSize ?? this.maxUploadFileSizeBytes;
      this.allowedTypes = fileConfig?.allowedTypes ?? this.allowedTypes;
      this.showAction = fileConfig?.showAction ?? this.showAction;
      this.needDragAndDrop = fileConfig?.needDragAndDrop ?? this.needDragAndDrop;
    } else {
      this.maxFileSize = this.maxFileSize ?? this.maxUploadFileSizeBytes;
    }
    this.loginUserId = sessionStorage.getItem('id') ? Number(sessionStorage.getItem('id')) : null;
    const storedRoleId = this.sessionStorage.getItem('role_id');
    const resolvedRoleId = storedRoleId ?? sessionStorage.getItem('role_id');
    this.loginUserRoleId = resolvedRoleId !== null && resolvedRoleId !== undefined && resolvedRoleId !== ''
      ? Number(resolvedRoleId)
      : null;
    this.applicationStatus = this.resolveApplicationStatusValue();
    this.syncArchivedTabVisibility();
    this.formIoService.getFormData().subscribe(data => {
      // Guard: if the user navigated away from the page this instance was created for,
      // stop processing form data to avoid stale state affecting the new page.
      const currentTitle = this.getSessionTitle();
      if (this.initialSessionTitle && currentTitle && currentTitle !== this.initialSessionTitle) {
        return;
      }
      this.formData = data;
      this.lastFormioChange = (data as any)?.changed ?? null;
      this.applicationStatus = this.resolveApplicationStatusValue();
      this.syncArchivedTabVisibility();
      this.checkReadOnlyMode();
      const formData = data?.data ?? data;
      const veteranStatusRaw = formData?.pf_veteran_status;
      const veteranStatus = Array.isArray(veteranStatusRaw) ? veteranStatusRaw[0] : veteranStatusRaw;
      // Check if legal name change status has changed
      const nameHistoryRaw = formData?.pf_name_history;
      const nameHistory = Array.isArray(nameHistoryRaw) ? nameHistoryRaw[0] : nameHistoryRaw;
      const isUpdateLegalName = this.normalizeBoolean(nameHistory?.is_update_legal_name);
      this.legalNameChangeRecordCount = this.getLegalNameChangeRecordCount(formData);
      if (isUpdateLegalName !== this.needsLegalNameChange) {
        this.needsLegalNameChange = isUpdateLegalName;
        this.syncLegalNameChangeRow();
      }

      // Check if active duty status has changed
      const isOnActiveDuty = this.normalizeOptionalBoolean(veteranStatus?.is_on_active_duty);
      const resolvedOnActiveDuty = isOnActiveDuty === true;
      if (!this.manualActiveDutySet && resolvedOnActiveDuty !== this.isOnActiveDuty) {
        this.isOnActiveDuty = resolvedOnActiveDuty;
        // Manually trigger the row addition/removal
        if (this.shouldShowProofOfServiceRow()) {
          this.addActiveDutyRow();
        } else {
          this.removeActiveDutyRow();
        }
      }

      // Check if veteran definition status has changed
      const isVeteranDefinition = this.normalizeOptionalBoolean(veteranStatus?.is_meets_veteran_definition);
      const resolvedVeteranDefinition = isVeteranDefinition === true;
      if (!this.manualVeteranDefinitionSet && resolvedVeteranDefinition !== this.isVeteranDefinition) {
        this.isVeteranDefinition = resolvedVeteranDefinition;
        if (this.shouldShowProofOfServiceRow()) {
          this.addActiveDutyRow();
        } else {
          this.removeActiveDutyRow();
        }
      }


      // Check if spouse on active duty status has changed
      const isSpouseOnActiveDuty = this.normalizeOptionalBoolean(veteranStatus?.is_spouse_on_active_duty);
      const resolvedSpouseOnActiveDuty = isSpouseOnActiveDuty === true;
      if (!this.manualSpouseActiveDutySet && resolvedSpouseOnActiveDuty !== this.isSpouseOnActiveDuty) {
        this.isSpouseOnActiveDuty = resolvedSpouseOnActiveDuty;
        if (resolvedSpouseOnActiveDuty === true) {
          this.addSpouseActiveDutyRow();
          this.addActiveDutyRow();
        } else if (resolvedSpouseOnActiveDuty === false) {
          this.removeSpouseActiveDutyRow();
          this.removeActiveDutyRow();
        }
      }

      // Check if spouse veteran status has changed
      const isSpouseVeteran =
        this.normalizeOptionalBoolean(veteranStatus?.is_spouse_of_veteran ?? veteranStatus?.is_spouse_veteran);
      const resolvedSpouseVeteran = isSpouseVeteran === true;
      if (!this.manualSpouseVeteranSet && resolvedSpouseVeteran !== this.isSpouseVeteran) {
        this.isSpouseVeteran = resolvedSpouseVeteran;
        if (resolvedSpouseVeteran === true) {
          this.addSpouseActiveDutyRow();
          this.addActiveDutyRow();
        } else if (resolvedSpouseVeteran === false) {
          this.removeSpouseActiveDutyRow();
          this.removeActiveDutyRow();
        }
      }

      // Professional-Development page logic
      const profDevDataRaw = formData?.application_professional_development;
      const profDevData = Array.isArray(profDevDataRaw) ? profDevDataRaw[0] : profDevDataRaw;

      if (this.getSessionTitle() === 'Professional-Development') {
        // Extract grid data arrays for dynamic row creation
        const districtGridRaw = formData?.districtGrid?.districtGrid || formData?.districtGrid;
        const newDistrictGridData = Array.isArray(districtGridRaw) ? districtGridRaw : [];

        const addProfDevRaw = formData?.addProfDevelopment?.addProfDevelopment || formData?.addProfDevelopment;
        const newAddProfDevData = Array.isArray(addProfDevRaw) ? addProfDevRaw : [];

        // Check if grid data has changed
        const districtGridChanged = JSON.stringify(this.districtGridData) !== JSON.stringify(newDistrictGridData);
        const addProfDevChanged = JSON.stringify(this.addProfDevelopmentData) !== JSON.stringify(newAddProfDevData);

        // Update grid data
        this.districtGridData = newDistrictGridData;
        this.addProfDevelopmentData = newAddProfDevData;

        // Store raw values for validation (preserve null/undefined)
        const isDistrictCharter = this.normalizeOptionalBoolean(profDevData?.is_district_charter_employed);
        this.rawDistrictCharterEmployed = isDistrictCharter;
        const resolvedDistrictCharter = isDistrictCharter === true;
        const districtFlagChanged = !this.manualDistrictCharterSet && resolvedDistrictCharter !== this.isDistrictCharterEmployed;
        if (districtFlagChanged) {
          this.isDistrictCharterEmployed = resolvedDistrictCharter;
        }

        const isAdditionalProf = this.normalizeOptionalBoolean(profDevData?.is_additional_prof_completed);
        this.rawAdditionalProfCompleted = isAdditionalProf;
        const resolvedAdditionalProf = isAdditionalProf === true;
        const addProfFlagChanged = !this.manualAdditionalProfSet && resolvedAdditionalProf !== this.isAdditionalProfCompleted;
        if (addProfFlagChanged) {
          this.isAdditionalProfCompleted = resolvedAdditionalProf;
        }

        // Track college coursework and credits fields
        const isCollegeCoursework = this.normalizeOptionalBoolean(profDevData?.is_college_univ_coursework);
        this.rawCollegeUnivCoursework = isCollegeCoursework;
        const resolvedCollegeCoursework = isCollegeCoursework === true;
        if (!this.manualCollegeUnivCourseworkSet && resolvedCollegeCoursework !== this.isCollegeUnivCoursework) {
          this.isCollegeUnivCoursework = resolvedCollegeCoursework;
        }

        const creditsEarned = profDevData?.college_univ_sem_credits_earned;
        this.rawCollegeUnivCreditsEarned = creditsEarned;
        if (!this.manualCollegeUnivCreditsSet && creditsEarned !== this.collegeUnivSemCreditsEarned) {
          this.collegeUnivSemCreditsEarned = creditsEarned;
        }

        // Sync rows if any relevant data changed (flag OR grid data)
        if (districtFlagChanged || addProfFlagChanged || districtGridChanged || addProfDevChanged) {
          this.syncProfessionalDevelopmentRows();
        }

        // Mark form fields as loaded once we receive any data
        this.profDevFormFieldsLoaded = true;
        this.updateNextButtonState();
      }

      if (this.getSessionTitle() === 'Education-Information' && !this.eduSyncInProgress) {
        try {
          const nvWrapper = formData?.nevadaTesting1;
          const nevadaTestingRaw = nvWrapper?.nevadaTesting1 ?? nvWrapper;
          const newNevadaTestingData = Array.isArray(nevadaTestingRaw) ? nevadaTestingRaw : [];

          const oosWrapper = formData?.outOfStateTesting1;
          const outOfStateTestingRaw = oosWrapper?.outOfStateTesting1 ?? oosWrapper;
          const newOutOfStateTestingData = Array.isArray(outOfStateTestingRaw) ? outOfStateTestingRaw : [];

          const nevadaGridChanged = JSON.stringify(this.nevadaTestingGridData) !== JSON.stringify(newNevadaTestingData);
          const outOfStateGridChanged = JSON.stringify(this.outOfStateTestingGridData) !== JSON.stringify(newOutOfStateTestingData);

          this.nevadaTestingGridData = newNevadaTestingData;
          this.outOfStateTestingGridData = newOutOfStateTestingData;
          if (nevadaGridChanged || outOfStateGridChanged) {
            this.invalidateDocTypesCache();
          }

          const isNevadaTesting = this.normalizeOptionalBoolean(formData?.chk_nevada_testing);
          this.rawNevadaTestingEnabled = isNevadaTesting;
          const resolvedNevadaTesting = isNevadaTesting === true;
          const nevadaFlagChanged = !this.manualNevadaTestingSet && resolvedNevadaTesting !== this.isNevadaTestingEnabled;
          if (nevadaFlagChanged) {
            this.isNevadaTestingEnabled = resolvedNevadaTesting;
          }

          const isOutOfStateTesting = this.normalizeOptionalBoolean(formData?.chk_out_of_state_testing);
          this.rawOutOfStateTestingEnabled = isOutOfStateTesting;
          const resolvedOutOfStateTesting = isOutOfStateTesting === true;
          const outOfStateFlagChanged = !this.manualOutOfStateTestingSet && resolvedOutOfStateTesting !== this.isOutOfStateTestingEnabled;
          if (outOfStateFlagChanged) {
            this.isOutOfStateTestingEnabled = resolvedOutOfStateTesting;
          }

          if (nevadaFlagChanged || outOfStateFlagChanged || nevadaGridChanged || outOfStateGridChanged) {
            this.syncEducationInformationRows();
          }

          this.eduFormFieldsLoaded = true;
          this.updateNextButtonState();
        } catch (err) {
          console.error('Education-Information form data processing error', err);
        }
      }

      this.syncUploadContext();
      this.getdocumenthistory();
      this.showCustomAction();
      this.evaluateDnqUploadWindow();
      this.syncLegalNameChangeRow();
    });
    this.loadDropdownData();
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
    this.oneFileIsRequired = false;
    const sub = this.pageBuilderService.refreshDocumentHistory$
      .subscribe(() => {
        this.getdocumenthistory(true);
      });
    this.subscription.add(sub);
    this.attachDocumentClickHandler();
  }

  private syncUploadContext(): void {
    try {
      const appShared = (this.appAuthService as any)?.getSharedMessage?.() || {};
      const dynamicShared = (this.authServices as any)?.getSharedMessage?.() || {};

      const pageId = this.getEffectiveFormId();

      const responseId = this.pickFirstDefined([
        appShared?.id,
        appShared?.responseId,
        dynamicShared?.id,
        dynamicShared?.responseId,
        this.formData?.data?.id,
        this.formData?.data?.responseId,
        this.formData?.data?.application_id
      ]);

      const payload: any = { ...dynamicShared, ...appShared };
      if (pageId !== undefined && pageId !== null && pageId !== '') {
        payload.pageId = pageId;
      }
      if (responseId !== undefined && responseId !== null && responseId !== '') {
        payload.id = responseId;
      }

      if (payload.pageId) {
        this.appAuthService.setSharedMessage(payload);
        (this.authServices as any)?.setSharedMessage?.(payload);
      }
    } catch (err) {
      console.error('Failed to sync upload context', err);
    }
  }

  private pickFirstDefined(values: any[]): any {
    for (const v of values) {
      if (v !== undefined && v !== null && v !== '') {
        return v;
      }
    }
    return undefined;
  }

  private getFormIdFromHistory(): any {
    const withFormId = (this.documentHistory || []).find((row: any) =>
      row?.formid || (row as any)?.formId || row?.pageId || (row as any)?.pageid
    );
    if (withFormId) {
      return withFormId.formid
        || (withFormId as any).formId
        || withFormId.pageId
        || (withFormId as any).pageid;
    }
    return undefined;
  }

  private getEffectiveFormId(): any {
    const appShared = (this.appAuthService as any)?.getSharedMessage?.() || {};
    const dynamicShared = (this.authServices as any)?.getSharedMessage?.() || {};

    return this.pickFirstDefined([
      this.formId,
      this.gridId,
      this.formData?.data?.pageDetails?.id,
      this.formData?.data?.pageDetails?.pageid,
      this.formData?.data?.pageDetails?.pageId,
      this.formData?.data?.pageId,
      appShared?.pageId,
      appShared?.pageid,
      dynamicShared?.pageId,
      dynamicShared?.pageid,
      this.getFormIdFromHistory()
    ]);
  }

  ngOnChanges(changes: any): void {
    if (changes['name'] && changes['name'].currentValue !== changes['name'].previousValue) {
      const rawName = changes['name'].currentValue;
      if (rawName) {
        this._formattedName = rawName.replace(/data\[(.+)\]/, '$1');
      }
    }
    if (changes['showArchived']) {
      this.syncArchivedTabVisibility();
    }
    if (changes['needsLegalNameChange']) {
      this.syncLegalNameChangeRow();
    }
    if (changes['readOnlyCondition'] && changes['readOnlyCondition'].currentValue !== changes['readOnlyCondition'].previousValue) {
      this.checkReadOnlyMode();
    }
  }
  private async loadDropdownData() {
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=DOCUMENT CATEGORY'),
      this.httpService.get('/domain/lookup?requestType=DOCUMENT TYPE'),
      this.httpService.get('/domain/lookup?requestType=PROGRAM PROVIDER')
    ]).subscribe({
      next: (item: any) => {
        // Get current application type from session storage
        const currApplicationType = this.getCurrApplicationType();

        const catPayload = item?.[0];
        const rawCategories = Array.isArray(catPayload?.data)
          ? catPayload.data
          : Array.isArray(catPayload?.data?.data)
            ? catPayload.data.data
            : (Array.isArray(catPayload) ? catPayload : []);
        const normalizedCats = this.normalizeCategories(rawCategories);
        const filteredCats = this.filterCategoriesByApplicationType(normalizedCats, currApplicationType);
        this.categories = (filteredCats.length ? filteredCats : normalizedCats).filter(c => c.key && c.value);
        if (!this.categories || !this.categories.length) {
          this.categories = this.getFallbackCategories();
        }
        console.log('DocumentUploadGrid: categories loaded', this.categories);
        const typePayload = item?.[1];
        const rawDocTypes = Array.isArray(typePayload?.data)
          ? typePayload.data
          : Array.isArray(typePayload?.data?.data)
            ? typePayload.data.data
            : (Array.isArray(typePayload) ? typePayload : []);
        const normalizedTypes = this.normalizeDocTypes(rawDocTypes);
        const filteredTypes = this.filterDocumentTypesByApplicationType(normalizedTypes, currApplicationType);
        this.documentTypes = (filteredTypes.length ? filteredTypes : normalizedTypes).filter(d => d.key && d.value);
        if (!this.documentTypes || !this.documentTypes.length) {
          this.documentTypes = this.getFallbackDocTypes();
        }

        const providerPayload = item?.[2];
        const rawProviders = Array.isArray(providerPayload?.data)
          ? providerPayload.data
          : Array.isArray(providerPayload?.data?.data)
            ? providerPayload.data.data
            : (Array.isArray(providerPayload) ? providerPayload : []);
        this.programProviderLookup = (rawProviders || []).map((d: any) => ({
          key: String(d?.key ?? d?.id ?? ''),
          value: String(d?.value ?? d?.name ?? ''),
          optionaldata: d?.optionaldata || null
        })).filter(d => d.key && d.value);

        console.log('DocumentUploadGrid===== categories loaded', this.categories);
        this.invalidateDocTypesCache();

        // Initialize filtered document types as empty (will be populated when category is selected)
        this.filteredDocumentTypes = [];

        // Auto-select category if only one option is available
        this.autoSelectSingleCategory();

        // Normalize any already-loaded documentHistory rows to use keys
        this.normalizeDocumentHistory();
        this.addDummyRow();
        this.syncLegalNameChangeRow();
        this.addActiveDutyRow();
        this.addSpouseActiveDutyRow();
        // Ensure button state is always updated after initialization
        this.updateNextButtonState();
        this.cdr.detectChanges();

        this.fetchApplicationProviderCode();
      },
      error: error => {
        console.error('Error loading dropdown data:', error);
        if (!this.categories || !this.categories.length) {
          this.categories = this.getFallbackCategories();
        }
        console.log('DocumentUploadGrid: =====>categories loaded', this.categories);
        if (!this.documentTypes || !this.documentTypes.length) {
          this.documentTypes = this.getFallbackDocTypes();
        }
        this.filteredDocumentTypes = [];
        this.syncLegalNameChangeRow();
        // Ensure button state is always updated even on error
        this.updateNextButtonState();
        this.cdr.detectChanges();
      }
    });
  }
  private fetchApplicationProviderCode(): void {
    const appId = this.getApplicationId();
    if (!appId) return;
    this.httpService.get(`/application-flow/application-provider/${appId}`).subscribe({
      next: (res: any) => {
        const rawData = res?.data || res || [];
        const rows = Array.isArray(rawData)
          ? rawData
          : Array.isArray(rawData?.data)
            ? rawData.data
            : (rawData ? [rawData] : []);
        const row = Array.isArray(rows) ? rows[0] : rows;
        this.applicationProviderCode = String(row?.cd_programprovider || '0').trim();
        this.invalidateDocTypesCache();
        this.syncEducationInformationRows();
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error('Error fetching application provider:', err);
        this.applicationProviderCode = '0';
      }
    });
  }
  getdocumenthistory(force = false) {
    const appShared = (this.appAuthService as any)?.getSharedMessage?.() || {};
    const dynamicShared = (this.authServices as any)?.getSharedMessage?.() || {};
    const sessionTitle = this.getSessionTitle();

    let pageId = this.pickFirstDefined([
      this.getEffectiveFormId(),
      appShared.pageId,
      appShared.pageid,
      dynamicShared.pageId,
      dynamicShared.pageid
    ]);
    const id = this.pickFirstDefined([
      appShared.id,
      appShared.responseId,
      dynamicShared.id,
      dynamicShared.responseId,
      this.formData?.data?.responseId,
      this.formData?.data?.id,
      this.sessionStorage.getItem('youthID')
    ]);

    if (!pageId || !id) {
      return;
    }

    const historyKey = `${pageId}-${id}`;
    if (!force && this.lastHistoryKey === historyKey) {
      return;
    }
    this.lastHistoryKey = historyKey;


    if(sessionTitle === "DOCUMENT_PAGE_CONSTANT.DOCUMENT_PAGE_TITLE"){
      pageId = 3564;
    }

    const cacheKey = `documents-${id}-${pageId}`;
    this.pageBuilderService.clearCacheForKey(cacheKey);
    this.pageBuilderService
      .getDocumentsHistory(id, pageId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.clearSelections();
          const mapped = (res?.data || []).map((item: any) => this.mapApiDocumentResponse(item));

          let ordered = mapped;
          if (mapped && mapped.length > 1) {
            const havePrimaryIds = mapped.every(m => m.primary_id !== undefined && m.primary_id !== null && m.primary_id !== '');
            if (havePrimaryIds) {
              ordered = mapped.sort((a: any, b: any) => {
                const pa = Number(a.primary_id || a.id || 0);
                const pb = Number(b.primary_id || b.id || 0);
                return pa - pb;
              });
            } else {
              const haveDates = mapped.every(m => !!m.createdat);
              if (haveDates) {
                ordered = mapped.sort((a: any, b: any) => {
                  const ta = new Date(a.createdat).getTime();
                  const tb = new Date(b.createdat).getTime();
                  return ta - tb;
                });
              } else {
                ordered = mapped.reverse();
              }
            }
          }
          this.documentHistory = ordered;
          this.invalidateDocTypesCache();
          this.removePlaceholderRows();
          this.normalizeDocumentHistory();
          this.hydrateCategoriesAndTypesFromHistory();
          this.addDummyRow();
          this.syncLegalNameChangeRow();
          this.addActiveDutyRow();
          this.addSpouseActiveDutyRow();
          this.applyDefaultRowOrdering();
          // Emit normalized array value for Form.io/back-end and notify listeners
          this.emitSupportingDocument([...this.documentHistory]);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.cdr.detectChanges();
        }
      });
  }

  private normalizeDocumentHistory(): void {
    if (!this.documentHistory || !this.documentHistory.length) {
      this.updateArchivedHistory();
      return;
    }
    if (!this.categories || !this.documentTypes) {
      this.updateArchivedHistory();
      return;
    }

    this.documentHistory = this.documentHistory.map((item: any) => {
      const normalized = { ...item };

      if (normalized.cd_document_category) {
        const cat = this.categories.find(c => c.key === normalized.cd_document_category || c.value === normalized.cd_document_category);
        if (cat) {
          normalized.cd_document_category = cat.key;
          // keep category_id if present, otherwise set it
          if (!normalized.category_id) {
            normalized.category_id = cat.key;
          }
        }
      }

      if (normalized.cd_document_type) {
        const dt = this.documentTypes.find(d => d.key === normalized.cd_document_type || d.value === normalized.cd_document_type);
        if (dt) {
          normalized.cd_document_type = dt.key;
        }
      }

      const uploadedByDisplay = this.resolveUploadedByDisplay(normalized);
      if (uploadedByDisplay) {
        normalized.created = uploadedByDisplay;
      } else if (!normalized.created) {
        normalized.created = normalized.created_by || normalized.createdBy || '';
      }

      return normalized;
    });

    this.updateArchivedHistory();
  }

  private syncArchivedTabVisibility(): void {
    this.archivedTabEnabled = this.shouldShowArchivedTab();
    if (!this.archivedTabEnabled) {
      this.activeDocumentTab = 'upload';
    }
    this.updateArchivedHistory();
  }

  private shouldShowArchivedTab(): boolean {
    if (!this.isArchivedFeatureEnabledByConfig()) {
      return false;
    }

    // Applicant:
    // Show Active/Archived tabs only when there is at least one archived/replaced row
    // (typically created by intake "replace file" action). Otherwise show upload section only.
    if (this.isApplicantDuplicateRole()) {
      return this.hasArchivedRowsInDocumentHistory();
    }

    // Staff/Admin: keep tabs visible.
    return true;
  }

  private isArchivedFeatureEnabledByConfig(): boolean {
    const configuredValue: any = this.showArchived;
    if (configuredValue === undefined || configuredValue === null) {
      return true;
    }
    if (typeof configuredValue === 'string' && configuredValue.trim() === '') {
      return true;
    }
    return this.normalizeBoolean(configuredValue);
  }

  private resolveApplicationStatusValue(): any {
    const formDataStatus = this.pickFirstDefined([
      this.formData?.data?.application_status,
      this.formData?.data?.applicationStatus,
      this.formData?.data?.cd_application_status
    ]);
    const navigationData = this.getSessionObject('navigationData');
    const navigationStatus = navigationData?.bannerheader?.['Application Status'];
    const rawSessionStatus = this.sessionStorage.getItem('applicationStatus') ?? sessionStorage.getItem('applicationStatus');
    let parsedSessionStatus: any = rawSessionStatus;

    if (typeof rawSessionStatus === 'string' && rawSessionStatus.trim() !== '') {
      try {
        parsedSessionStatus = JSON.parse(rawSessionStatus);
      } catch {
        parsedSessionStatus = rawSessionStatus;
      }
    }

    return this.pickFirstDefined([
      formDataStatus,
      this.applicationStatus,
      navigationStatus,
      parsedSessionStatus
    ]);
  }

  private hasArchivedRowsInDocumentHistory(): boolean {
    return (this.documentHistory || []).some((row: any) => this.isArchivedDocument(row));
  }

  private updateArchivedHistory(): void {
    // Re-evaluate tab visibility when document history changes (e.g., after replace/archive actions).
    this.archivedTabEnabled = this.shouldShowArchivedTab();
    this.uploadDocumentHistory = this.filterUploadDocuments(this.documentHistory || []);
    if (!this.archivedTabEnabled) {
      this.archivedDocumentHistory = [];
      this.activeDocumentTab = 'upload';
      return;
    }
    this.archivedDocumentHistory = this.filterArchivedDocuments(this.documentHistory || []);
  }

  private filterUploadDocuments(rows: any[]): any[] {
    if (this.shouldShowArchivedRowsInActiveTab()) {
      return [...(rows || [])];
    }
    return (rows || []).filter(row => !this.isArchivedDocument(row));
  }

  private filterArchivedDocuments(rows: any[]): any[] {
    return (rows || []).filter(row => this.isArchivedDocument(row));
  }

  private buildDocumentIdentityKey(row: any): string {
    if (!row || typeof row !== 'object') {
      return '';
    }
    const rowKey = row.primary_id || row.document_id || row.id;
    if (rowKey !== null && rowKey !== undefined && rowKey !== '') {
      return `id:${String(rowKey)}`;
    }
    const rowPath = String(row.path || row.file_hash || '').trim().toLowerCase();
    const rowFileName = String(row.file_name || row.filename || row.name || '').trim().toLowerCase();
    const rowCategory = this.normalizeCategoryKey(row.cd_document_category || row.category_id);
    if (!rowPath && !rowFileName && !rowCategory) {
      return '';
    }
    return `file:${rowPath}|${rowFileName}|${rowCategory}`;
  }

  private snapshotArchivedUploaderMetadata(rows: any[]): Map<string, any> {
    const snapshot = new Map<string, any>();
    (rows || [])
      .filter((row: any) => this.isArchivedDocument(row))
      .forEach((row: any) => {
        const key = this.buildDocumentIdentityKey(row);
        if (!key) {
          return;
        }
        const uploadedByDisplay = this.resolveUploadedByDisplay(row);
        snapshot.set(key, {
          created: row.created || uploadedByDisplay || '',
          created_by: row.created_by,
          createdBy: row.createdBy,
          created_by_id: row.created_by_id,
          createdById: row.createdById,
          uploaded_by: row.uploaded_by || row.uploadedBy || uploadedByDisplay || '',
          uploadedBy: row.uploadedBy || row.uploaded_by || uploadedByDisplay || ''
        });
      });
    return snapshot;
  }

  private restoreArchivedUploaderMetadata(snapshot: Map<string, any>): void {
    if (!snapshot || snapshot.size === 0 || !Array.isArray(this.documentHistory) || !this.documentHistory.length) {
      return;
    }

    this.documentHistory = this.documentHistory.map((row: any) => {
      if (!this.isArchivedDocument(row)) {
        return row;
      }
      const key = this.buildDocumentIdentityKey(row);
      if (!key || !snapshot.has(key)) {
        return row;
      }
      const preserved = snapshot.get(key) || {};
      const preservedDisplay = this.resolveUploadedByDisplay(preserved);
      const created = preserved.created || preservedDisplay || row.created || '';
      const uploadedBySnake =
        preserved.uploaded_by
        || preserved.uploadedBy
        || preservedDisplay
        || row.uploaded_by
        || row.uploadedBy
        || '';
      const uploadedByCamel =
        preserved.uploadedBy
        || preserved.uploaded_by
        || preservedDisplay
        || row.uploadedBy
        || row.uploaded_by
        || '';
      return {
        ...row,
        created,
        created_by: preserved.created_by ?? row.created_by,
        createdBy: preserved.createdBy ?? row.createdBy,
        created_by_id: preserved.created_by_id ?? row.created_by_id,
        createdById: preserved.createdById ?? row.createdById,
        uploaded_by: uploadedBySnake,
        uploadedBy: uploadedByCamel
      };
    });
  }

  private shouldShowArchivedRowsInActiveTab(): boolean {
    // Applicant view does not expose the Archived tab, so keep archived rows visible in Active Documents.
    return this.isApplicantDuplicateRole() && !this.archivedTabEnabled;
  }

  isDocumentTabActive(tab: 'upload' | 'archived'): boolean {
    return this.activeDocumentTab === tab;
  }

  setActiveDocumentTab(tab: 'upload' | 'archived'): void {
    if (tab === 'archived' && !this.archivedTabEnabled) {
      return;
    }
    if (this.activeDocumentTab === tab) {
      return;
    }
    this.activeDocumentTab = tab;
    this.clearSelections();
  }

  getActiveDocumentSectionTitle(): string {
    return this.activeDocumentTab === 'archived' ? 'Archived Documents' : 'Upload Documents';
  }

  private isArchivedDocument(row: any): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }
    if ((row as any).isPlaceholder) {
      return false;
    }
    const archivedFlag = (row as any).is_archived
      ?? (row as any).isArchived
      ?? (row as any).archived
      ?? (row as any).archive;
    if (this.normalizeBoolean(archivedFlag)) {
      return true;
    }
    const status = String((row as any).status || (row as any).document_status || (row as any).documentStatus || '')
      .trim()
      .toLowerCase();
    if (status === 'archived' || status === 'replaced') {
      return true;
    }
    const archivalStatus = String((row as any).archival_status || (row as any).archive_status || '')
      .trim()
      .toLowerCase();
    return archivalStatus === 'archived' || archivalStatus === 'replaced';
  }

  private mapApiDocumentResponse(item: any): any {
    if (!item) {
      return item;
    }

    const fileName = item.file_name || item.filename || item.name || '';
    const path = item.path || item.file_hash || '';
    const categoryValue = item.description || item.category || '';
    const typeValue = item.attachmenttype || item.filetype || '';
    // Normalize/lookup document type against loaded domain documentTypes.
    let normalizedType = typeValue || '';
    let documentTypeName = typeValue ? String(typeValue) : '';

    try {
      // If no category was provided by the uploader, treat type as not provided
      if (!categoryValue) {
        normalizedType = '';
        documentTypeName = 'Not provided';
      } else {
        const raw = String(typeValue || '').trim();
        const lookupKey = raw.toLowerCase();
        if (this.documentTypes && this.documentTypes.length) {
          const match = this.documentTypes.find((d: any) => {
            const k = String(d.key || '').toLowerCase();
            const v = String(d.value || '').toLowerCase();
            return k === lookupKey || v === lookupKey || v.includes(lookupKey) || k.includes(lookupKey);
          });
          if (match) {
            normalizedType = match.key;
            documentTypeName = match.value || raw;
          } else {
            documentTypeName = raw ? raw.toUpperCase() : '';
          }
        } else {
          documentTypeName = raw ? raw.toUpperCase() : '';
        }
      }
    } catch (e) {
      documentTypeName = String(typeValue || '');
    }

    const uploadedByDisplay = this.resolveUploadedByDisplay(item);

    return {
      ...item,
      id: item.document_id || item.primary_id || item.id,
      file_name: fileName,
      path,
      file_hash: path,
      cd_document_category: categoryValue,
      cd_document_type: normalizedType,
      document_type_name: documentTypeName,
      category_id: item.category_id || categoryValue,
      attachmenttype: item.attachmenttype || item.filetype || '',
      status: item.status || item.document_status || 'Uploaded',
      document_notes: item.document_notes || item.documentNotes || item.deficient_reason || item.deficiency_reason || '',
      deficient_reason: item.deficient_reason || item.document_notes || item.documentNotes || '',
      uploaded_by: item.uploaded_by || item.uploadedBy || uploadedByDisplay || '',
      uploadedBy: item.uploadedBy || item.uploaded_by || uploadedByDisplay || '',
      created: uploadedByDisplay || item.created || item.created_by || item.createdBy || '',
      createdat: item.createdat || item.created_date || item.updatedat || null,
      display_order: item.display_order ?? item.sort_order ?? item.order ?? item.sequence ?? null,
    };
  }

  private resolveUploadedByDisplay(row: any): string {
    if (!row || typeof row !== 'object') {
      return '';
    }
    return String(
      row.uploaded_by_name
      || row.uploadedByName
      || row.uploaded_by
      || row.uploadedBy
      || row.created
      || row.created_by_name
      || row.createdByName
      || row.created_by
      || row.createdBy
      || ''
    ).trim();
  }

  isDeficientStatus(row: any): boolean {
    const status = String(row?.status || row?.document_status || row?.documentStatus || '').trim().toLowerCase();
    return status === 'deficient';
  }

  getDeficiencyNotes(row: any): string {
    return String(
      row?.document_notes
      || row?.documentNotes
      || row?.deficient_reason
      || row?.deficiency_reason
      || ''
    ).trim();
  }

  openDeficiencyNotesModal(doc: any, template: any): void {
    this.selectedDocForAction = doc;
    this.deficiencyNotesView = this.getDeficiencyNotes(doc);
    this.modalref = this.modalService.open(template, { size: 'md', backdrop: 'static', centered: true });
  }

  private removePlaceholderRows(): void {
    const rows = this.documentHistory || [];
    const nonPlaceholderCategories = new Set(
      rows
        .filter(row => row && !(row as any).isPlaceholder)
        .map(row => this.getRowCategoryKey(row))
        .filter(Boolean)
    );

    this.documentHistory = rows.filter(row => {
      if (!(row as any)?.isPlaceholder) {
        return true;
      }
      const categoryKey = this.getRowCategoryKey(row);
      // Keep placeholder rows if they are the only row for that category.
      return !categoryKey || !nonPlaceholderCategories.has(categoryKey);
    });
  }

  onView(doc: any): void {
    const fileUrl = this.getFileUrl(doc);
    if (!fileUrl) {
      this.alertService.error('Unable to preview document.');
      return;
    }
    this.previewDoc = doc;
    this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileUrl);
    this.modalref = this.modalService.open(this.viewModel, {
      size: 'xl',
      backdrop: 'static',
      windowClass: 'document-preview-modal'
    });
  }

  private getFileUrl(doc: any): string {
    return doc?.url || doc?.path || doc?.file_hash || '';
  }

  private getFileExtension(doc: any): string {
    const rawName = doc?.file_name || doc?.filename || doc?.name || this.getFileUrl(doc);
    if (!rawName || typeof rawName !== 'string') {
      return '';
    }
    const clean = rawName.split('?')[0].split('#')[0];
    const idx = clean.lastIndexOf('.');
    return idx >= 0 ? clean.slice(idx + 1).toLowerCase() : '';
  }

  isPdf(doc: any): boolean {
    const ext = this.getFileExtension(doc);
    if (ext === 'pdf') {
      return true;
    }
    const type = String(doc?.attachmenttype || doc?.filetype || '').toLowerCase();
    return type === 'application/pdf' || type.includes('pdf');
  }

  isImage(doc: any): boolean {
    const ext = this.getFileExtension(doc);
    if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(ext)) {
      return true;
    }
    const type = String(doc?.attachmenttype || doc?.filetype || '').toLowerCase();
    return type.startsWith('image/');
  }

  onDownload(doc: any): void {
    const fileUrl = this.getFileUrl(doc);
    const filename = doc.filename || 'downloaded-file';
    this.http.get(fileUrl, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      },
      error: (err) => {
        console.error('Failed to download document:', err);
      }
    });
  }

  onDelete(doc: any, deleteModel: any): void {
    if (!this.canDeleteDocument(doc)) {
      this.alertService.error('You cannot delete this document in the current application status.');
      return;
    }
    this.deleteId = doc;
    const modalTemplate = deleteModel || this.deleteModelTemplate;
    this.modalref = this.modalService.open(modalTemplate, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'add-appointment-details'
    });
    if (this.modalref && this.modalref.componentInstance) {
      this.modalref.componentInstance.title = 'Delete Document';
    }
  }

  canDeleteDocument(row: any): boolean {
    if (!row) {
      return false;
    }
    if (this.isInProgressNotSubmittedApplicationStatus()) {
      return true;
    }
    return this.canStaffOrAdminDeleteNewReviewDocument(row);
  }

  private canStaffOrAdminDeleteNewReviewDocument(row: any): boolean {
    if (!this.isStaffOrAdminRole()) {
      return false;
    }
    if (!this.isReviewPhaseApplicationStatus()) {
      return false;
    }
    if (!this.isRowPendingReview(row)) {
      return false;
    }
    return this.hasStaffAdminReviewOrigin(row);
  }

  private hasStaffAdminReviewOrigin(row: any): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }

    const hasExplicitFlag =
      this.normalizeBoolean((row as any).staffAdminReviewUpload)
      || this.normalizeBoolean((row as any).staff_admin_review_upload);
    if (hasExplicitFlag) {
      return true;
    }

    const rawOrigin = String(
      (row as any).document_origin
      ?? (row as any).documentOrigin
      ?? (row as any).upload_origin
      ?? (row as any).uploadOrigin
      ?? (row as any).origin
      ?? ''
    ).trim().toLowerCase();

    return rawOrigin === 'staff_admin_pending_review_upload'
      || rawOrigin === 'staff admin pending review upload';
  }

  private isInProgressNotSubmittedApplicationStatus(): boolean {
    const normalized = this.normalizeApplicationStatus(this.applicationStatus);
    if (!normalized) {
      return false;
    }
    if (normalized === '16' || normalized === 'draft') {
      return true;
    }
    if (normalized === 'in progress' || normalized === 'not submitted') {
      return true;
    }
    return normalized.includes('in progress') && normalized.includes('not submitted');
  }

  private isReviewPhaseApplicationStatus(): boolean {
    const normalized = this.normalizeApplicationStatus(this.applicationStatus);
    if (!normalized) {
      return false;
    }
    return !this.isInProgressNotSubmittedApplicationStatus();
  }

  private isRowPendingReview(row: any): boolean {
    const status = String(row?.status || row?.document_status || row?.documentStatus || '')
      .trim()
      .toLowerCase();
    return status === 'pending review';
  }

  private normalizeApplicationStatus(status: any): string {
    if (status === undefined || status === null) {
      return '';
    }
    if (typeof status === 'object') {
      const nestedStatus =
        status?.applicationStatus
        ?? status?.value
        ?? status?.label
        ?? status?.status
        ?? status?.key;
      if (nestedStatus !== undefined && nestedStatus !== null) {
        return String(nestedStatus).trim().toLowerCase().replace(/\s+/g, ' ');
      }
    }
    return String(status).trim().toLowerCase().replace(/\s+/g, ' ');
  }

  private isStaffOrAdminRole(): boolean {
    const roleId = this.getCurrentRoleId();
    if (!roleId) {
      return false;
    }
    return roleId === ROLE_ID.NDE_Administrator
      || roleId === ROLE_ID.NDE_Reviewer
      || roleId === ROLE_ID.NDE_Analyst
      || roleId === ROLE_ID.NDE_LeadAnalyst
      || roleId === ROLE_ID.Licensing_Analyst
      || roleId === ROLE_ID.Licensing_LeadAnalyst
      || roleId === ROLE_ID.Licensing_Technician
      || roleId === ROLE_ID.Licensing_LeadTechnician;
  }

  private getUploadedFileCount(): number {
    return (this.documentHistory || []).filter(row =>
      !!row?.file_name && !(row as any).isPlaceholder
    ).length;
  }

  private shouldRemoveRowOnDelete(row: any): boolean {
    if (!row) {
      return false;
    }
    const categoryKey = this.getRowCategoryKey(row);
    const categoryRowCount = this.getCategoryRowCount(categoryKey);

    if (categoryRowCount > 1) {
      return true;
    }

    if (row.keepRowOnDelete || this.isRequiredCategoryKey(categoryKey)) {
      return false;
    }

    // Professional-Development dynamic rows (district/provider):
    // Only remove if the corresponding grid item no longer exists.
    // If the grid item still exists, keep the row as placeholder so user can upload a new document.
    const isDynamicByType = (row as any).profDevGridType === 'districtCharter' || (row as any).profDevGridType === 'providerName';
    const isDynamicByTracking = this.dynamicDistrictCategoryKeys.has(row.cd_document_category) ||
                                 this.dynamicProviderCategoryKeys.has(row.cd_document_category);
    if (isDynamicByType || isDynamicByTracking) {
      // Check if grid item still exists
      const categoryName = row.cd_document_category;
      const isDistrictType = (row as any).profDevGridType === 'districtCharter' || this.dynamicDistrictCategoryKeys.has(categoryName);
      const isProviderType = (row as any).profDevGridType === 'providerName' || this.dynamicProviderCategoryKeys.has(categoryName);

      if (isDistrictType) {
        // Check if district grid still has this item
        const stillExistsInGrid = (this.districtGridData || []).some(
          (item: any) => item?.district_charter_name_text === categoryName
        );
        // If still exists in grid, DON'T remove - keep as placeholder
        if (stillExistsInGrid) {
          return false;
        }
      }

      if (isProviderType) {
        // Check if provider grid still has this item
        const stillExistsInGrid = (this.addProfDevelopmentData || []).some(
          (item: any) => item?.provider_name_text === categoryName
        );
        // If still exists in grid, DON'T remove - keep as placeholder
        if (stillExistsInGrid) {
          return false;
        }
      }

      // Grid item was removed, so remove the document row too
      return true;
    }

    if (this.isRadioControlledCategoryKey(categoryKey)) {
      return true;
    }

    // When only one file exists, keep the row and just clear the file.
    if (this.getUploadedFileCount() <= 1) {
      return false;
    }
    // When multiple files exist, delete the entire row.
    return true;
  }

  private removeOrClearRowByIndex(idx: number): void {
    const row = { ...this.documentHistory[idx] } as any;
    const shouldRemove = this.shouldRemoveRowOnDelete(row);
    if (shouldRemove) {
      this.documentHistory.splice(idx, 1);
      this.documentHistory = [...this.documentHistory]; // Trigger change detection with new array ref
      return;
    }
    row.file_name = '';
    row.path = '';
    row.file_hash = '';
    row.cd_document_type = '';
    row.document_type = '';
    row.document_type_name = '';
    row.status = '';
    row.createdat = null;
    row.created = '';
    row.primary_id = null;
    row.document_id = null;
    row.isPlaceholder = true;

    // Detect and set profDevGridType for dynamic categories if not already set
    // This ensures rows from API can be properly identified during cleanup
    if (!row.profDevGridType && row.cd_document_category) {
      const categoryKey = row.cd_document_category;
      if (this.dynamicDistrictCategoryKeys.has(categoryKey)) {
        row.profDevGridType = 'districtCharter';
        row.autoManagedCategoryRow = true;
      } else if (this.dynamicProviderCategoryKeys.has(categoryKey)) {
        row.profDevGridType = 'providerName';
        row.autoManagedCategoryRow = true;
      }
    }

    this.documentHistory[idx] = row;
    this.documentHistory = [...this.documentHistory]; // Trigger change detection with new array ref
  }

  onDeleteItem(): void {
    // Prefer clearing file fields on the matched row (keep the row) instead of removing entire row
    let handled = false;
    if (this.deleteId) {
      const idx = (this.documentHistory || []).indexOf(this.deleteId);
      if (idx !== -1) {
        this.removeOrClearRowByIndex(idx);
        handled = true;
      }
    }

    const deleteKey = this.deleteId?.primary_id || this.deleteId?.id || this.deleteId?.document_id;
    if (!handled && deleteKey) {
      const idx = (this.documentHistory || []).findIndex(d => {
        const itemKey = (d as any).primary_id || (d as any).id || (d as any).document_id;
        return itemKey === deleteKey;
      });
      if (idx !== -1) {
          this.removeOrClearRowByIndex(idx);
          handled = true;
      }
    }

    if (!handled && this.deleteId?.path && this.deleteId?.file_name) {
      const idx = (this.documentHistory || []).findIndex(d => d.path === this.deleteId.path && d.file_name === this.deleteId.file_name);
      if (idx !== -1) {
          this.removeOrClearRowByIndex(idx);
          handled = true;
      }
    }

    if (!handled && this.deleteId?.file_name) {
      const idx = (this.documentHistory || []).findIndex(d => d.file_name === this.deleteId.file_name &&
        (this.deleteId.cd_document_category ? d.cd_document_category === this.deleteId.cd_document_category : true));
      if (idx !== -1) {
          this.removeOrClearRowByIndex(idx);
          handled = true;
      }
    }

    if (!handled) {
      // No matching row found � do nothing to avoid accidental deletions
      this.alertService.error('Unable to locate the document to delete.');
      this.modalService.dismissAll();
      return;
    }
    // On Professional-Development page, skip addDummyRow (which triggers syncProfessionalDevelopmentRows)
    // to prevent re-adding the row that was just deleted by the user.
    if (this.getSessionTitle() !== 'Professional-Development') {
      this.addDummyRow();
    }
    this.emitSupportingDocument(this.documentHistory);
    this.alertService.success('File deleted successfully.');
    this.closePopup();
    this.cdr.detectChanges();
  }

  closePopup(): void {
    this.previewDoc = null;
    this.previewUrl = null;
    this.modalService.dismissAll();
  }

  onSelectionChanged(e: any) {
    this.selectedDocuments = e.selectedRowsData || [];
  }

  private emitSupportingDocument(documentHistory: any[]): void {
    this.updateNextButtonState();
    this.updateArchivedHistory();

    if (!this._formattedName) {
      return;
    }
    const key = this._formattedName;
    const defaultFormId = this.getEffectiveFormId();

    const docs = (documentHistory || [])
      .filter((row: any) => !!row && !!row.file_name && !row.isPlaceholder)
      .map((row: any) => {
        const normalized = { ...row };
        const resolvedFormId = defaultFormId
          ?? normalized.formid
          ?? (normalized as any).formId
          ?? normalized.pageId
          ?? (normalized as any).pageid;

        normalized.formid = resolvedFormId;
        (normalized as any).formId = resolvedFormId;
        return normalized;
      });

    // Build a names-based payload for submission: convert cd_document_* keys into display names
    const namesValue = docs.map((d: any) => {
      const categoryName = this.categories?.find(c => String(c.key) === String(d.cd_document_category) || String(c.value) === String(d.cd_document_category))?.value || d.category_name || d.cd_document_category || '';
      const docTypeName = this.documentTypes?.find(dt => String(dt.key) === String(d.cd_document_type) || String(dt.value) === String(d.cd_document_type))?.value || d.document_type_name || d.cd_document_type || '';
      const resolvedFormId = d.formid ?? (d as any).formId ?? defaultFormId;

      return {
        ...d,
        formid: resolvedFormId,
        formId: resolvedFormId,
        cd_document_category: categoryName,
        cd_document_type: docTypeName
      };
    });

    // Expose the names-based array as the component value so form submissions carry human-readable names
    this.value = namesValue;
    this.valueChange.emit(this.value);

    this.formioEvent?.emit({
      eventName: 'supportingDocuments',
      data: {
        value: docs,
        namesValue: namesValue,
        type: key,
        key: key,
      }
    });
  }

  openConfirmValidModal(doc: any, template: any): void {
    if (!doc) {
      return;
    }
    this.selectedDocForAction = doc;
    this.modalref = this.modalService.open(template, { size: 'md', backdrop: 'static', centered: true });
  }

  onConfirmValidProceed(): void {
    if (!this.selectedDocForAction) {
      return;
    }
    const doc = this.selectedDocForAction;
    this.applyReviewDecisionToDocumentHistory(doc, 'Validated');
    // Keep selected/grid object in sync for immediate UI refresh.
    doc.status = 'Validated';
    doc.document_status = 'Validated';
    doc.status_date = now();
    this.emitSupportingDocument(this.documentHistory);
    this.formioEvent?.emit({ eventName: 'documentAction', data: { action: 'markValid', document: doc } });
    this.alertService.success('Document marked as valid.');
    this.modalService.dismissAll();
    this.selectedDocForAction = null;
    this.cdr.detectChanges();
  }

  onConfirmValidCancel(modal?: any): void {
    if (modal?.close) {
      modal.close();
    }
    if (this.modalref) {
      this.modalref.close();
    }
    this.selectedDocForAction = null;
  }

  openDeficientModal(doc: any, template: any): void {
    this.selectedDocForAction = doc;
    this.deficiencyReason = '';
    this.deficiencyError = '';
    this.modalref = this.modalService.open(template, { size: 'md', backdrop: 'static' });
  }

  onSaveDeficiency(): void {
    if (!this.selectedDocForAction) return;
    if (!this.deficiencyReason || this.deficiencyReason.trim().length === 0) {
      this.deficiencyError = 'Please enter deficiency notes.';
      return;
    }
    this.deficiencyError = '';

    const doc = this.selectedDocForAction;
    const documentId = doc.document_id || doc.primary_id || doc.primaryId || doc.documentId || doc.id;
    const reason = this.deficiencyReason.trim();

    // Newly uploaded rows may not have a persisted document id yet.
    // Keep the UX consistent by marking the row deficient locally and emitting the update.
    if (!documentId) {
      this.finalizeDeficiencyUpdate(doc, reason, false);
      return;
    }

    const payload = {
      status: 'Deficient',
      reason,
      status_date: Date.now(),
      documentId,
    };

    // Call the API
    this.pageBuilderService.markDocumentDeficient(payload)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          // On success, update UI and emit events
          this.finalizeDeficiencyUpdate(doc, reason, true);
        },
        error: (error) => {
          this.alertService.error('Failed to mark document as deficient. Please try again.');
          console.error('API Error:', error);
        }
      });
  }

  private finalizeDeficiencyUpdate(doc: any, reason: string, refreshFromServer: boolean): void {
    this.applyReviewDecisionToDocumentHistory(doc, 'Deficient', reason);
    doc.status = 'Deficient';
    doc.document_status = 'Deficient';
    doc.deficient_reason = reason;
    doc.document_notes = reason;
    doc.status_date = now();
    this.emitSupportingDocument(this.documentHistory);
    this.formioEvent?.emit({ eventName: 'documentAction', data: { action: 'markDeficient', document: doc } });
    this.alertService.success('Document marked as deficient.');
    if (refreshFromServer) {
      this.getdocumenthistory();
    }
    this.modalService.dismissAll();
    this.selectedDocForAction = null;
    this.deficiencyReason = '';
    this.cdr.detectChanges();
  }

  private applyReviewDecisionToDocumentHistory(doc: any, status: 'Validated' | 'Deficient', notes: string = ''): void {
    if (!doc || !Array.isArray(this.documentHistory) || !this.documentHistory.length) {
      return;
    }

    const targetKey = doc.document_id || doc.primary_id || doc.id;
    const targetPath = String(doc.path || doc.file_hash || '').trim();
    const targetName = String(doc.file_name || doc.name || '').trim().toLowerCase();
    const targetCategory = this.normalizeCategoryKey(doc.cd_document_category || doc.category_id);

    this.documentHistory = this.documentHistory.map((row: any) => {
      if (!row || row.isPlaceholder || this.isArchivedDocument(row) || this.isDeletedDocumentRow(row)) {
        return row;
      }

      const rowKey = row.document_id || row.primary_id || row.id;
      const rowPath = String(row.path || row.file_hash || '').trim();
      const rowName = String(row.file_name || row.name || '').trim().toLowerCase();
      const rowCategory = this.normalizeCategoryKey(row.cd_document_category || row.category_id);

      const keyMatch = !!(targetKey && rowKey && String(targetKey) === String(rowKey));
      const pathMatch = !!(targetPath && rowPath && targetPath === rowPath);
      const nameCategoryMatch = !!(targetName && targetCategory && rowName === targetName && rowCategory === targetCategory);

      if (!keyMatch && !pathMatch && !nameCategoryMatch) {
        return row;
      }

      return {
        ...row,
        status,
        document_status: status,
        status_date: now(),
        document_notes: status === 'Deficient' ? notes : (row.document_notes || ''),
        deficient_reason: status === 'Deficient' ? notes : (row.deficient_reason || '')
      };
    });
  }

  openReplaceModal(doc: any, template: any): void {
    this.syncUploadContext();
    this.selectedDocForAction = doc;
    this.replaceUploadData = null;
    this.replaceUploadError = '';
    this.modalref = this.modalService.open(template, { size: 'lg', backdrop: 'static', centered: true });
    this.isReplaceFlow = true;
  }

  onReplaceFileUploaded(fileInfo: any): void {
    try {
      const nextUploadData =
        fileInfo?.detail?.data?.value?.fileInfo
        || fileInfo?.data?.value?.fileInfo
        || fileInfo?.fileInfo
        || fileInfo
        || null;
      const uploadedAttachments = this.extractReplacementAttachments(nextUploadData);

      // Ignore empty init events from upload component; show no validation until a file is actually uploaded.
      if (!uploadedAttachments.length) {
        this.replaceUploadData = null;
        this.replaceUploadError = '';
        return;
      }

      this.replaceUploadData = nextUploadData;
      this.replaceUploadError = '';
    } catch (err) {
      console.error('Replace upload event parse error:', err);
      this.replaceUploadError = 'Failed to read uploaded file.';
    }
  }

  onReplaceSave(): void {
    if (!this.canUploadDocuments()) {
      this.alertService.error(this.dnqUploadMessage || 'Upload window has expired for this DNQ application.');
      return;
    }
    if (!this.selectedDocForAction) return;
    if (!this.replaceUploadData) {
      this.alertService.error('Please upload a replacement file first.');
      return;
    }
    const archivedUploaderSnapshot = this.snapshotArchivedUploaderMetadata(this.documentHistory || []);
    const newAttachment = this.resolveReplacementAttachment(this.replaceUploadData, this.selectedDocForAction);
    if (!newAttachment) {
      this.alertService.error('Please upload a different replacement file.');
      return;
    }
    const oldDoc = { ...this.selectedDocForAction };
    const replacementDoc = this.buildReplacementDocument(oldDoc, newAttachment);
    const archivedDoc = this.buildArchivedDocument(oldDoc);
    const oldUploaderDisplay = this.resolveUploadedByDisplay(oldDoc);
    archivedDoc.created = oldDoc?.created || oldUploaderDisplay || archivedDoc.created;
    archivedDoc.created_by = oldDoc?.created_by || archivedDoc.created_by;
    archivedDoc.createdBy = oldDoc?.createdBy || archivedDoc.createdBy;
    archivedDoc.created_by_id = oldDoc?.created_by_id || archivedDoc.created_by_id;
    archivedDoc.createdById = oldDoc?.createdById || archivedDoc.createdById;
    archivedDoc.uploaded_by =
      oldDoc?.uploaded_by
      || oldDoc?.uploadedBy
      || oldUploaderDisplay
      || archivedDoc.uploaded_by;
    archivedDoc.uploadedBy =
      oldDoc?.uploadedBy
      || oldDoc?.uploaded_by
      || oldUploaderDisplay
      || archivedDoc.uploadedBy;
    const currentIndex = this.findDocumentIndexForReplacement(this.selectedDocForAction, oldDoc);
    const nextHistory = [...(this.documentHistory || [])];
    if (currentIndex !== -1) {
      nextHistory.splice(currentIndex, 1);
    }

    const oldKey = oldDoc?.primary_id || oldDoc?.id || oldDoc?.document_id;
    const oldPath = String(oldDoc?.path || oldDoc?.file_hash || '').trim();
    const oldFileName = String(oldDoc?.file_name || oldDoc?.filename || oldDoc?.name || '').trim().toLowerCase();
    const oldCategoryKey = this.normalizeCategoryKey(oldDoc?.cd_document_category || oldDoc?.category_id);

    const cleanedHistory = nextHistory.filter((row: any) => {
      const rowKey = row?.primary_id || row?.id || row?.document_id;
      if (oldKey && rowKey && String(oldKey) === String(rowKey)) {
        return false;
      }

      const rowPath = String(row?.path || row?.file_hash || '').trim();
      const rowFileName = String(row?.file_name || row?.filename || row?.name || '').trim().toLowerCase();
      const rowCategoryKey = this.normalizeCategoryKey(row?.cd_document_category || row?.category_id);

      if (oldPath && rowPath && oldPath === rowPath) {
        return false;
      }
      if (oldFileName && oldCategoryKey && rowFileName === oldFileName && rowCategoryKey === oldCategoryKey) {
        return false;
      }

      return true;
    });

    this.documentHistory = [...cleanedHistory, archivedDoc, replacementDoc];
    this.restoreArchivedUploaderMetadata(archivedUploaderSnapshot);

    this.emitSupportingDocument(this.documentHistory);
    this.formioEvent?.emit({
      eventName: 'documentAction',
      data: {
        action: 'replaceFile',
        oldDocument: archivedDoc,
        previousDocument: oldDoc,
        newDocument: replacementDoc,
        uploadInfo: this.replaceUploadData
      }
    });
    this.alertService.success('Replacement uploaded successfully.');
    this.modalService.dismissAll();
    this.selectedDocForAction = null;
    this.replaceUploadData = null;
    this.replaceUploadError = '';
    this.activeDocumentTab = 'upload';
    this.uploadedFiles = [];
    this.isReplaceFlow = false;
    this.cdr.detectChanges();
  }

  private resolveReplacementAttachment(uploadData: any, currentDoc: any): any | null {
    const attachments = this.extractReplacementAttachments(uploadData);
    if (!attachments.length) {
      return null;
    }

    const currentPath = String(currentDoc?.path || currentDoc?.file_hash || '').trim();
    const currentName = String(currentDoc?.file_name || currentDoc?.name || '').trim().toLowerCase();

    const changedAttachments = attachments.filter((attachment: any) => {
      const attachmentPath = String(attachment?.path || attachment?.file_hash || '').trim();
      const attachmentName = String(attachment?.name || attachment?.file_name || '').trim().toLowerCase();

      const isPathChanged = !!attachmentPath && !!currentPath && attachmentPath !== currentPath;
      const isNameChanged = !!attachmentName && !!currentName && attachmentName !== currentName;

      // If current doc has no path/name, allow the candidate.
      if (!currentPath && !currentName) {
        return true;
      }

      return isPathChanged || isNameChanged;
    });

    if (changedAttachments.length > 0) {
      // latest attachment in upload response should be considered the replacement
      return changedAttachments[changedAttachments.length - 1];
    }

    return null;
  }

  private extractReplacementAttachments(uploadData: any): any[] {
    if (!uploadData) {
      return [];
    }

    const directAttachments = Array.isArray(uploadData?.attachmentdetails) ? uploadData.attachmentdetails : [];
    const nestedAttachments = Array.isArray(uploadData?.fileInfo?.attachmentdetails) ? uploadData.fileInfo.attachmentdetails : [];
    const arrayPayload = Array.isArray(uploadData) ? uploadData : [];
    const candidates = [...directAttachments, ...nestedAttachments, ...arrayPayload];

    return candidates.filter((attachment: any) => this.isValidUploadFile(attachment));
  }

  private findDocumentIndexForReplacement(selectedDoc: any, fallbackDoc: any): number {
    if (!Array.isArray(this.documentHistory) || !this.documentHistory.length) {
      return -1;
    }

    const byReference = this.documentHistory.indexOf(selectedDoc);
    if (byReference !== -1) {
      return byReference;
    }

    const key = selectedDoc?.primary_id || selectedDoc?.id || selectedDoc?.document_id
      || fallbackDoc?.primary_id || fallbackDoc?.id || fallbackDoc?.document_id;
    if (key) {
      const byKey = this.documentHistory.findIndex((d: any) => {
        const itemKey = d?.primary_id || d?.id || d?.document_id;
        return String(itemKey) === String(key);
      });
      if (byKey !== -1) {
        return byKey;
      }
    }

    const selectedPath = String(selectedDoc?.path || selectedDoc?.file_hash || fallbackDoc?.path || fallbackDoc?.file_hash || '').trim();
    const selectedFileName = String(
      selectedDoc?.file_name || selectedDoc?.filename || selectedDoc?.name
      || fallbackDoc?.file_name || fallbackDoc?.filename || fallbackDoc?.name
      || ''
    ).trim().toLowerCase();

    if (selectedPath || selectedFileName) {
      const byPathAndName = this.documentHistory.findIndex((d: any) => {
        const rowPath = String(d?.path || d?.file_hash || '').trim();
        const rowFileName = String(d?.file_name || d?.filename || d?.name || '').trim().toLowerCase();

        if (selectedPath && selectedFileName) {
          return rowPath === selectedPath && rowFileName === selectedFileName;
        }
        if (selectedPath) {
          return rowPath === selectedPath;
        }
        return rowFileName === selectedFileName;
      });

      if (byPathAndName !== -1) {
        return byPathAndName;
      }
    }

    const selectedCategoryKey = this.normalizeCategoryKey(
      selectedDoc?.cd_document_category
      || selectedDoc?.category_id
      || fallbackDoc?.cd_document_category
      || fallbackDoc?.category_id
    );
    if (selectedFileName && selectedCategoryKey) {
      const byCategoryAndFileName = this.documentHistory.findIndex((d: any) => {
        const rowCategoryKey = this.normalizeCategoryKey(d?.cd_document_category || d?.category_id);
        const rowFileName = String(d?.file_name || d?.filename || d?.name || '').trim().toLowerCase();
        return rowCategoryKey === selectedCategoryKey && rowFileName === selectedFileName;
      });
      if (byCategoryAndFileName !== -1) {
        return byCategoryAndFileName;
      }
    }

    return -1;
  }

  private buildArchivedDocument(sourceDoc: any): any {
    const archivedAt = now();
    return {
      ...sourceDoc,
      status: 'Archived',
      document_status: 'Archived',
      status_date: archivedAt,
      replaced_date: archivedAt,
      archived_date: archivedAt,
      archival_date: archivedAt,
      is_archived: true,
      archived: true,
      archive: true,
      archival_status: 'Archived',
      archive_status: 'Archived',
      is_active: false
    };
  }

  private buildReplacementDocument(sourceDoc: any, attachment: any): any {
    const uploadedAt = now();
    const personData = this.getSessionObject('personData');
    const createdBy = this.getUploaderDisplayName(personData);
    const createdById = this.getUploaderId(personData);
    const nextPath = attachment?.path || attachment?.file_hash || sourceDoc?.path || sourceDoc?.file_hash || '';
    const nextFileName = attachment?.name || attachment?.file_name || sourceDoc?.file_name || '';

    return {
      ...sourceDoc,
      primary_id: attachment?.primary_id || attachment?.primaryId || null,
      id: attachment?.document_id || attachment?.primary_id || attachment?.primaryId || attachment?.id || null,
      document_id: attachment?.document_id || null,
      file_name: nextFileName,
      path: nextPath,
      file_hash: nextPath,
      attachmenttype: attachment?.attachmenttype || attachment?.type || sourceDoc?.attachmenttype || 'application/octet-stream',
      status: 'Pending Review',
      document_status: 'Pending Review',
      status_date: uploadedAt,
      created_by: createdById || sourceDoc?.created_by || '',
      created: createdBy || sourceDoc?.created || '',
      uploaded_by: createdBy || sourceDoc?.uploaded_by || sourceDoc?.uploadedBy || sourceDoc?.created || '',
      uploadedBy: createdBy || sourceDoc?.uploadedBy || sourceDoc?.uploaded_by || sourceDoc?.created || '',
      created_date: uploadedAt,
      createdat: uploadedAt,
      replaced_date: uploadedAt,
      is_archived: false,
      archived: false,
      archive: false,
      archival_status: '',
      archive_status: '',
      archival_date: null,
      archived_date: null,
      is_active: true,
      addedFromUploadModal: true
    };
  }

  getSelectedCount(): number {
    const selectedRows = this.dataGrid?.instance?.getSelectedRowsData();
    return selectedRows ? selectedRows.length : 0;
  }

  clearSelections(): void {
    this.selectedDocuments = [];
    if (this.dataGrid?.instance) {
      this.dataGrid.instance.clearSelection();
    }
    this.cdr.detectChanges();
  }

  addTooltipToSelectAll(): void {
    const selectAllCheckbox = document.querySelector('.dx-datagrid-checkbox-size.dx-select-checkbox');
    if (selectAllCheckbox && !selectAllCheckbox.getAttribute('title')) {
      selectAllCheckbox.setAttribute('title', 'Select All');
    }
  }

  ngOnDestroy(): void {
    this.detachDocumentClickHandler();
    this.clearNextButtonStateSyncTimers();
    // Re-enable buttons so this dying instance doesn't leave them permanently disabled
    try { this.applyNextButtonState(false); } catch (_e) { /* noop */ }
    this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getCurrApplicationType(): string {
    try {
      const currApplicationType = this.sessionStorage.getItem('currApplicationType');

      if (currApplicationType) {
        // Handle different possible formats
        if (currApplicationType.startsWith('"') && currApplicationType.endsWith('"')) {
          // JSON string format: "Name Change"
          return JSON.parse(currApplicationType);
        } else {
          // Plain string format: Name Change
          return currApplicationType;
        }
      }
      return '';
    } catch (error) {
      console.error('Error parsing currApplicationType from session:', error);
      return '';
    }
  }

  private isLicensePathRestricted(): boolean {
    const rawLicPath = (this.sessionStorage.getItem('license-path') ?? sessionStorage.getItem('license-path') ?? '').toString().trim();
    const licPath = rawLicPath.replace(/^["']|["']$/g, '');
    if (!['1', '2', '4'].includes(licPath)) return true;

    const providerCode = parseInt(this.applicationProviderCode || '0', 10);
    if (!providerCode || providerCode <= 0) return true;

    return false;
  }

  private isProviderTraditional(): boolean {
    if (!this.applicationProviderCode || !this.programProviderLookup.length) return false;
    const match = this.programProviderLookup.find(
      p => String(p.key) === String(this.applicationProviderCode)
    );
    if (!match?.optionaldata) return false;
    try {
      const data = typeof match.optionaldata === 'string'
        ? JSON.parse(match.optionaldata) : match.optionaldata;
      return data?.Traditional === true;
    } catch {
      return false;
    }
  }

  private getSessionTitle(): string {
    try {
      const titleData = this.sessionStorage.getItem('get-title');

      if (titleData) {
        // Handle different possible formats
        if (titleData.startsWith('"') && titleData.endsWith('"')) {
          // JSON string format: "Personal-Info-Details-Page"
          return JSON.parse(titleData);
        } else {
          // Plain string format: Personal-Info-Details-Page
          return titleData;
        }
      }
      return '';
    } catch (error) {
      console.error('Error parsing get-title from session:', error);
      return '';
    }
  }

  private normalizeCategories(categories: any[]): any[] {
    if (!Array.isArray(categories)) {
      return [];
    }
    return categories
      .map((c: any, idx: number) => {
        const key = c?.key ?? c?.id ?? c?.code ?? c?.value ?? c?.name ?? `cat-${idx}`;
        const value = c?.value ?? c?.name ?? c?.description ?? c?.label ?? c?.text ?? key;
        return { key: String(key), value: String(value) };
      })
      .filter(c => c.key && c.value);
  }

  private normalizeDocTypes(docTypes: any[]): any[] {
    if (!Array.isArray(docTypes)) {
      return [];
    }
    return docTypes
      .map((d: any, idx: number) => {
        const key = d?.key ?? d?.id ?? d?.code ?? d?.value ?? d?.name ?? `doc-${idx}`;
        const value = d?.value ?? d?.name ?? d?.description ?? d?.label ?? d?.text ?? key;
        return { key: String(key), value: String(value) };
      })
      .filter(d => d.key && d.value);
  }

  private getFallbackCategories(): any[] {
    return [...this.fallbackCategories];
  }

  private getFallbackDocTypes(): any[] {
    return [...this.fallbackDocTypes];
  }

  private filterCategoriesByApplicationType(categories: any[], currApplicationType: string): any[] {
    const sessionTitle = this.getSessionTitle();

    // License-Details-Page logic
    if (sessionTitle === 'License-Details-Page') {
      if (currApplicationType === 'Apprentice') {
        const allowedCategories = ['Apprentice Letter'];
        return categories.filter(category => allowedCategories.includes(category.value));
      }
      if (currApplicationType === 'ARL (Alternative Route to Licensure)') {
        const allowedCategories = ['ARL Certificate'];
        return categories.filter(category => allowedCategories.includes(category.value));
      }
      if (currApplicationType === 'Regular - Initial') {
        const allowedCategories = ['Out-of-State or Country Licensure'];
        return categories.filter(category => allowedCategories.includes(category.value));
      }
    }

    // Personal-Info-Details-Page logic
    if (sessionTitle === 'Personal-Info-Details-Page') {
      if (currApplicationType === 'Name Change') {
        // Existing Name Change logic
        const allowedCategories = [
          'Proof of Photo Identification',
          'Proof of Legal Name Change'
        ];
        return categories.filter(category => allowedCategories.includes(category.value));
      } else {
        // For other application types on Personal-Info-Details-Page
        const allowedCategories = [
          'Proof of Legal Name Change',
          'Proof of Photo Identification',
          'Proof of Relationship',
          'Proof of Service'
        ];
        return categories.filter(category => allowedCategories.includes(category.value));
      }
    }
    // Case-personal-information page logic
    if (sessionTitle === 'Case-personal-information') {
      const allowedCategories = [
          'Proof of Legal Name Change',
          'Proof of Photo Identification',
          'Proof of Relationship',
          'Proof of Service'
        ];
        return categories.filter(category => allowedCategories.includes(category.value));
    }

    // Education-Information page logic
    if (sessionTitle === 'Education-Information') {
      const eduCategories = [
        'High School Diploma or Equivalent',
        'Nevada Testing Score Report',
        'Out-of-State Testing Score Report'
      ];
      if (!this.isLicensePathRestricted()) {
        eduCategories.push(this.EDU_CAT_ARL);
        if (!this.isProviderTraditional()) {
          eduCategories.push(this.EDU_CAT_PROOF);
        }
      }
      return categories.filter(category => eduCategories.includes(category.value));
    }

    // Work-Experience-reg page logic
    if (sessionTitle === 'Work-Experience-reg') {
      const allowedCategories = ['Proof of Service'];
      return categories.filter(category => allowedCategories.includes(category.value));
    }

    // Background-check page logic
    if (sessionTitle === 'Background-check') {
      const allowedCategories = ['History Disclosure Documentation'];
      return categories.filter(category => allowedCategories.includes(category.value));
    }

    // Professional-Development page logic
    if (sessionTitle === 'Professional-Development') {
      const allowedCategories = [
        'District / Charter School Name',
        'Provider Name'
      ];
      return categories.filter(category => allowedCategories.includes(category.value));
    }

    // Return all categories for other application types or pages
    return categories;
  }

  private filterDocumentTypesByApplicationType(documentTypes: any[], currApplicationType: string): any[] {
    // Check if it's a Name Change application
    if (currApplicationType === 'Name Change') {
      const sessionTitle = this.getSessionTitle();

      // Check if the current page is Personal-Info-Details-Page
      if (sessionTitle === 'Personal-Info-Details-Page') {
        // Define allowed document types for Name Change
        const allowedDocumentTypes = [
          // For Proof of Photo Identification
          'Driver\'s License',
          'Passport',
          'State-Issued Identification Card',
          // For Proof of Legal Name Change
          'Adoption Decree',
          'Court Order for Name Change',
          'Divorce Decree',
          'Marriage Certificate',
          'Naturalization Certificate',
          'Other Legal Name Change Document'
        ];

        return documentTypes.filter(docType =>
          allowedDocumentTypes.includes(docType.value)
        );
      }
    }

    // Return all document types for other application types or pages
    return documentTypes;
  }

  private invalidateDocTypesCache(): void {
    this.docTypesCacheVersion++;
  }

  private getDocumentTypesForCategory(categoryKey: string): any[] {
    if (!categoryKey) {
      return [];
    }

    const cached = this.docTypesCache.get(categoryKey);
    if (cached && cached.version === this.docTypesCacheVersion) {
      return cached.result;
    }

    const result = this.computeDocumentTypesForCategory(categoryKey);
    this.docTypesCache.set(categoryKey, { version: this.docTypesCacheVersion, result });
    return result;
  }

  private computeDocumentTypesForCategory(categoryKey: string): any[] {
    const selectedCategory = this.categories.find(cat => cat.key === categoryKey);
    if (!selectedCategory) {
      return [];
    }

    const categoryName = selectedCategory.value;

    if (categoryName === 'Nevada Testing Score Report') {
      return (this.nevadaTestingGridData || [])
        .map((item: any) => item?.test_name)
        .filter(Boolean)
        .map((name: string) => ({ key: name, value: name }));
    }
    if (categoryName === 'Out-of-State Testing Score Report') {
      return (this.outOfStateTestingGridData || [])
        .map((item: any) => item?.test_name)
        .filter(Boolean)
        .map((name: string) => ({ key: name, value: name }));
    }
    if (categoryName === this.EDU_CAT_ARL || categoryName === this.EDU_CAT_PROOF) {
      const providerCode = this.applicationProviderCode;
      if (providerCode && this.programProviderLookup.length) {
        const match = this.programProviderLookup.find(
          p => String(p.key) === String(providerCode)
        );
        if (match) {
          return [{ key: match.key, value: match.value }];
        }
      }
      return [{ key: categoryName, value: categoryName }];
    }

    // Check if this is a dynamic Professional Development category
    const isProfDevDistrictCategory = this.isDynamicDistrictCharterCategory(categoryKey);
    const isProfDevProviderCategory = this.isDynamicProviderNameCategory(categoryKey);

    // Define document types for each category
    const categoryDocumentTypes: { [key: string]: string[] } = {
      'Proof of Photo Identification': [
        'Driver\'s License',
        'Passport',
        'State-Issued Identification Card'
      ],
      'Proof of Legal Name Change': [
        'Adoption Decree',
        'Court Order for Name Change',
        'Divorce Decree',
        'Marriage Certificate',
        'Naturalization Certificate',
        'Other Legal Name Change Document'
      ],
      'Proof of Service': [
        'Military ID Card',
        'DD Form 214'
      ],
      'Proof of Relationship': [
        'Marriage Certificate'
      ],
      'High School Diploma or Equivalent': [
        'High School Diploma / Transcript',
        'GED Certificate / Transcript'
      ],
      'Nevada Testing Score Report': [
        // No specific document types - user can upload without doctype
      ],
      'Out-of-State Testing Score Report': [
        // No specific document types - user can upload without doctype
      ],
      'ARL Certificate': [
        // No specific document types - user can upload without doctype
      ],
      'Apprentice Letter': [
        // No specific document types - user can upload without doctype
      ],
      'History Disclosure Documentation': [
        // No specific document types - user can upload without doctype
      ],
      'Out-of-State or Country Licensure': [
        // No specific document types - user can upload without doctype
      ],
      'District / Charter School Name': [
        'District / Charter Training Transcript',
        'Professional Development Certificate'
      ],
      'Provider Name': [
        'Professional Development Certificate',
        'Proof of Completion',
        'Transcripts'
      ]
    };

    // Handle dynamic Professional Development categories
    let allowedDocTypes: string[] = [];
    if (isProfDevDistrictCategory) {
      // Use same doc types as 'District / Charter School Name'
      allowedDocTypes = categoryDocumentTypes['District / Charter School Name'] || [];
    } else if (isProfDevProviderCategory) {
      // Use same doc types as 'Provider Name'
      allowedDocTypes = categoryDocumentTypes['Provider Name'] || [];
    } else {
      allowedDocTypes = categoryDocumentTypes[categoryName] || [];
    }

    // If we have no mapping, return all types
    if (!allowedDocTypes.length) {
      return this.documentTypes || [];
    }

    return (this.documentTypes || []).filter(docType =>
      allowedDocTypes.includes(docType.value)
    );
  }

  /**
   * Check if a category is a dynamic district charter category (from districtGridData)
   */
  private isDynamicDistrictCharterCategory(categoryKey: string): boolean {
    if (!categoryKey) {
      return false;
    }
    // Check tracking set first (faster)
    if (this.dynamicDistrictCategoryKeys.has(categoryKey)) {
      return true;
    }
    // Then check current grid data
    if (this.districtGridData && this.districtGridData.length) {
      return this.districtGridData.some((item: any) =>
        item?.district_charter_name_text === categoryKey
      );
    }
    return false;
  }

  /**
   * Check if a category is a dynamic provider name category (from addProfDevelopmentData)
   */
  private isDynamicProviderNameCategory(categoryKey: string): boolean {
    if (!categoryKey) {
      return false;
    }
    // Check tracking set first (faster)
    if (this.dynamicProviderCategoryKeys.has(categoryKey)) {
      return true;
    }
    // Then check current grid data
    if (this.addProfDevelopmentData && this.addProfDevelopmentData.length) {
      return this.addProfDevelopmentData.some((item: any) =>
        item?.provider_name_text === categoryKey
      );
    }
    return false;
  }

  /**
   * Remove dynamically-added district/provider categories from this.categories
   * that no longer have corresponding grid data items. This keeps the upload modal
   * category dropdown in sync with the current grid state in real-time.
   * Uses the tracking sets (dynamicDistrictCategoryKeys / dynamicProviderCategoryKeys)
   * to reliably identify dynamic categories even after rows have been removed.
   */
  private cleanupStaleDynamicCategories(): void {
    if (!this.categories || !this.categories.length) {
      return;
    }

    // Build sets of current dynamic names from live grid data
    const currentDistrictNames = new Set(
      (this.districtGridData || []).map((item: any) => item?.district_charter_name_text).filter(Boolean)
    );
    const currentProviderNames = new Set(
      (this.addProfDevelopmentData || []).map((item: any) => item?.provider_name_text).filter(Boolean)
    );

    const keysToRemove = new Set<string>();

    // Find stale district categories
    this.dynamicDistrictCategoryKeys.forEach(key => {
      const cat = this.categories.find(c => c.key === key);
      const catValue = cat?.value || key;
      if (!currentDistrictNames.has(catValue) && !currentDistrictNames.has(key)) {
        // Only remove if no uploaded files exist for this category
        const hasUploadedFiles = (this.documentHistory || []).some(
          (row: any) => row.cd_document_category === key && !!row.file_name
        );
        if (!hasUploadedFiles) {
          keysToRemove.add(key);
        }
      }
    });

    // Find stale provider categories
    this.dynamicProviderCategoryKeys.forEach(key => {
      const cat = this.categories.find(c => c.key === key);
      const catValue = cat?.value || key;
      if (!currentProviderNames.has(catValue) && !currentProviderNames.has(key)) {
        const hasUploadedFiles = (this.documentHistory || []).some(
          (row: any) => row.cd_document_category === key && !!row.file_name
        );
        if (!hasUploadedFiles) {
          keysToRemove.add(key);
        }
      }
    });

    if (keysToRemove.size > 0) {
      this.categories = this.categories.filter(cat => !keysToRemove.has(cat.key));
      // Also clean up the tracking sets
      keysToRemove.forEach(key => {
        this.dynamicDistrictCategoryKeys.delete(key);
        this.dynamicProviderCategoryKeys.delete(key);
      });
      this.invalidateDocTypesCache();
    }
  }

  private hydrateCategoriesAndTypesFromHistory(): void {
    if (!this.documentHistory || !this.documentHistory.length) {
      return;
    }

    if (!this.categories || !this.categories.length) {
      const uniqueCats = Array.from(new Set(
        this.documentHistory
          .map((d: any) => d.category_name || d.cd_document_category)
          .filter(Boolean)
      ));
      this.categories = uniqueCats.map((c: any) => ({
        key: c,
        value: c
      }));
      console.log('Hydrated categories from history:', this.categories);
    }

    if (!this.documentTypes || !this.documentTypes.length) {
      const uniqueTypes = Array.from(new Set(
        this.documentHistory
          .map((d: any) => d.document_type_name || d.cd_document_type)
          .filter(Boolean)
      ));
      this.documentTypes = uniqueTypes.map((t: any) => ({
        key: t,
        value: t
      }));
    }
  }

  isNameChangeApplication(): boolean {
    const currApplicationType = this.getCurrApplicationType();
    const sessionTitle = this.getSessionTitle();
    return currApplicationType === 'Name Change' && sessionTitle === 'Personal-Info-Details-Page';
  }

  private shouldShowLegalNameChangeRow(): boolean {
    return this.isNameChangeApplication() || this.needsLegalNameChange === true;
  }

  private syncLegalNameChangeRow(): void {
    if (!this.shouldShowLegalNameChangeRow()) {
      this.removeLegalNameChangeRow();
      this.updateNextButtonState();
      return;
    }
    const requiredCount = Math.max(1, this.legalNameChangeRecordCount || 0);
    this.ensureLegalNameChangeRows(requiredCount);
  }

  isDocumentTypeRequired(): boolean {
    if (!this.uploadData.category) {
      return false;
    }

    const selectedCategory = this.categories.find(cat => cat.key === this.uploadData.category);
    if (!selectedCategory) {
      return false;
    }
    console.log("categorys in===",this.categories);

    const categoryName = selectedCategory.value;

    return !this.optionalDocTypeCategories.includes(categoryName);
  }

  private isDocumentTypeRequiredForRow(row: any): boolean {
    if (!row || !row.cd_document_category) {
      return false;
    }
    const categoryName =
      this.categories?.find(cat => cat.key === row.cd_document_category || cat.value === row.cd_document_category)?.value
      || row.category_name
      || row.cd_document_category;

    return !!categoryName && !this.optionalDocTypeCategories.includes(categoryName);
  }

  private hasPendingRequiredUploads(): boolean {
    const rows = this.documentHistory || [];
    const sessionTitle = this.getSessionTitle();

    console.log('=== hasPendingRequiredUploads DEBUG ===');
    console.log('sessionTitle:', sessionTitle);
    console.log('total rows:', rows.length);
    console.log('documentHistory:', JSON.parse(JSON.stringify(rows)));

    // Check if there are placeholder rows that need files uploaded
    const hasPlaceholderRowsNeedingFiles = rows.some((row: any) => {
      if (!row || !row.isPlaceholder) {
        return false;
      }
      // Placeholder row needs a file uploaded
      if (row.file_name) {
        return false;
      }

      // For Professional-Development, only require uploads based on form flags
      if (sessionTitle === 'Professional-Development') {
        // Check if this is a dynamically created row from grid data
        if ((row as any).profDevGridType === 'districtCharter') {
          return this.isDistrictCharterEmployed;
        }
        if ((row as any).profDevGridType === 'providerName') {
          return this.isAdditionalProfCompleted;
        }

        const categoryName = this.categories?.find(
          cat => cat.key === row.cd_document_category || cat.value === row.cd_document_category
        )?.value || row.cd_document_category;

        if (categoryName === 'District / Charter School Name') {
          return this.isDistrictCharterEmployed;
        }
        if (categoryName === 'Provider Name') {
          return this.isAdditionalProfCompleted;
        }

        // Check if category matches any dynamic district charter name
        if (this.isDistrictCharterEmployed && this.districtGridData?.length > 0) {
          const isDistrictRow = this.districtGridData.some(item =>
            item?.district_charter_name_text === categoryName || item?.district_charter_name_text === row.cd_document_category
          );
          if (isDistrictRow) {
            return true;
          }
        }

        // Check if category matches any dynamic provider name
        if (this.isAdditionalProfCompleted && this.addProfDevelopmentData?.length > 0) {
          const isProviderRow = this.addProfDevelopmentData.some(item =>
            item?.provider_name_text === categoryName || item?.provider_name_text === row.cd_document_category
          );
          if (isProviderRow) {
            return true;
          }
        }

        // Unknown category - not required
        return false;
      }

      if (sessionTitle === 'Education-Information') {
        // Nevada Testing and Out-of-State Testing score report uploads are optional;
        // do not block the Next button for these placeholder rows.
        if ((row as any).eduGridType === this.EDU_GRID_TYPE_NEVADA) {
          console.log('[EDU] Skipping Nevada Testing placeholder row (optional) - eduGridType:', (row as any).eduGridType);
          return false;
        }
        if ((row as any).eduGridType === this.EDU_GRID_TYPE_OUT_OF_STATE) {
          console.log('[EDU] Skipping Out-of-State Testing placeholder row (optional) - eduGridType:', (row as any).eduGridType);
          return false;
        }

        const categoryName = this.categories?.find(
          cat => cat.key === row.cd_document_category || cat.value === row.cd_document_category
        )?.value || row.cd_document_category;

        if (this.EDU_STATIC_CATEGORIES.includes(categoryName)) {
          console.log('[EDU] BLOCKING: Static category placeholder needs file:', categoryName, 'row:', JSON.parse(JSON.stringify(row)));
          return true;
        }
        console.log('[EDU] Non-static category placeholder (not blocking):', categoryName, 'eduGridType:', (row as any).eduGridType, 'row:', JSON.parse(JSON.stringify(row)));
        return false;
      }

      // For other pages, placeholder rows require files
      return true;
    });
    console.log('[hasPendingRequiredUploads] hasPlaceholderRowsNeedingFiles:', hasPlaceholderRowsNeedingFiles);
    if (hasPlaceholderRowsNeedingFiles) {
      return true;
    }

    const hasPendingUploadRequirements = rows.some((row: any) => {
      if (!row || !row.cd_document_category) {
        return false;
      }
      if (row.isPlaceholder || this.isArchivedDocument(row) || this.isDeletedDocumentRow(row)) {
        return false;
      }
      const missingFile = !row.file_name;
      const missingDocType = this.isDocumentTypeRequiredForRow(row) && !row.cd_document_type;
      if (missingFile || missingDocType) {
        console.log('[hasPendingRequiredUploads] BLOCKING row - missingFile:', missingFile, 'missingDocType:', missingDocType, 'row:', JSON.parse(JSON.stringify(row)));
      }
      return missingFile || missingDocType;
    });
    console.log('[hasPendingRequiredUploads] hasPendingUploadRequirements:', hasPendingUploadRequirements);
    if (hasPendingUploadRequirements) {
      return true;
    }

    console.log('[hasPendingRequiredUploads] => NOT blocking');
    return false;
  }

  private shouldEnforceReviewDecisionBeforeNavigation(): boolean {
    return this.isShowMarkAsValid === true || this.isShowMarkAsDificient === true;
  }

  private isDocumentAwaitingReviewDecision(row: any): boolean {
    if (!row || row.isPlaceholder || this.isArchivedDocument(row) || this.isDeletedDocumentRow(row)) {
      return false;
    }

    const hasFile = !!(row.file_name || row.name || row.path || row.file_hash);
    if (!hasFile) {
      return false;
    }

    const status = String(row.status || row.document_status || row.documentStatus || '')
      .trim()
      .toLowerCase();
    if (!status) {
      return true;
    }
    return status !== 'validated' && status !== 'deficient' && status !== 'valid';
  }

  private hasPendingReviewDecisionDocuments(): boolean {
    if (!this.shouldEnforceReviewDecisionBeforeNavigation()) {
      console.log('[hasPendingReviewDecision] Review enforcement not active (isShowMarkAsValid:', this.isShowMarkAsValid, 'isShowMarkAsDificient:', this.isShowMarkAsDificient, ')');
      return false;
    }
    const rows = this.documentHistory || [];
    const blockingRow = rows.find((row: any) => this.isDocumentAwaitingReviewDecision(row));
    if (blockingRow) {
      console.log('[hasPendingReviewDecision] BLOCKING: row awaiting review decision:', JSON.parse(JSON.stringify(blockingRow)));
    }
    return !!blockingRow;
  }

  private applyNextButtonState(disable: boolean): void {
    try {
      this.clearNextButtonStateSyncTimers();
      const syncState = () => {
        const navigationButtons = this.getWorkflowNavigationButtons();
        navigationButtons.forEach((btn: HTMLButtonElement) => {
          btn.disabled = disable;
          btn.classList.toggle('disabled', disable);
          btn.setAttribute('aria-disabled', String(disable));
        });
      };

      syncState();
      [150, 450, 900].forEach((delay: number) => {
        const timerId = window.setTimeout(syncState, delay);
        this.nextButtonStateSyncTimers.push(timerId);
      });
    } catch (err) {
      console.error('Failed to toggle Next button state', err);
    }
  }

  private getWorkflowNavigationButtons(): HTMLButtonElement[] {
    const selector = [
      '#assessmentForm button',
      '.formio-form button',
      '.formio-component-form button',
      'button[name="data[submit]"]',
      'button.btn-wizard-nav-next',
      'button.btn-wizard-nav-submit',
      'button.formio-button-next',
      'button.formio-button-submit'
    ].join(', ');

    const allButtons = Array.from(document.querySelectorAll<HTMLButtonElement>(selector));
    const uniqueButtons = Array.from(new Set(allButtons));
    return uniqueButtons.filter((button: HTMLButtonElement) => this.isWorkflowNavigationButton(button));
  }

  private isWorkflowNavigationButton(button: HTMLButtonElement): boolean {
    const className = String(button.className || '');
    if (this.wizardNavigationClassPattern.test(className)) {
      return true;
    }

    const label = String(
      button.textContent
      || button.innerText
      || button.getAttribute('aria-label')
      || button.getAttribute('title')
      || ''
    ).trim().toLowerCase();

    return label.includes('next')
      || label.includes('submit')
      || label.includes('move')
      || label.includes('continue');
  }

  private attachDocumentClickHandler(): void {
    if (this.isDocumentClickHandlerAttached) {
      return;
    }
    document.addEventListener('click', this.documentClickHandler, true);
    this.isDocumentClickHandlerAttached = true;
  }

  private detachDocumentClickHandler(): void {
    if (!this.isDocumentClickHandlerAttached) {
      return;
    }
    document.removeEventListener('click', this.documentClickHandler, true);
    this.isDocumentClickHandlerAttached = false;
  }

  private onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement | null;
    const button = target?.closest('button') as HTMLButtonElement | null;
    if (!button) {
      return;
    }
    if (!this.isWorkflowSubmitButton(button)) {
      return;
    }
    this.triggerNameChangeResubmissionStatusUpdate();
  }

  private isWorkflowSubmitButton(button: HTMLButtonElement): boolean {
    if (button.disabled) {
      return false;
    }

    if (button.closest('.upload-form-popup, .modal-dialog, ngb-modal-window, .add-appointment-details')) {
      return false;
    }

    const className = String(button.className || '');
    const label = String(
      button.textContent
      || button.innerText
      || button.getAttribute('aria-label')
      || button.getAttribute('title')
      || ''
    ).trim().toLowerCase();

    if (this.wizardSubmitClassPattern.test(className)) {
      return label.includes('submit');
    }

    const isWorkflowButton = !!button.closest('#assessmentForm, .formio-form, .formio-component-form');
    return isWorkflowButton && label.includes('submit');
  }

  private isNameChangePersonalInfoResubmissionContext(): boolean {
    const applicationType = String(this.getCurrApplicationType() || '').trim().toLowerCase();
    if (applicationType !== 'name change') {
      return false;
    }

    const sessionTitle = String(this.getSessionTitle() || '').trim().toLowerCase();
    if (sessionTitle !== 'personal-info-details-page') {
      return false;
    }

    const currentStatus = this.resolveApplicationStatusValue();
    return this.isDeficiencyApplicationStatus(currentStatus);
  }

  private isDeficiencyApplicationStatus(status: any): boolean {
    const normalized = String(status ?? '').trim().toLowerCase();
    if (!normalized) {
      return false;
    }
    return normalized === '19' || normalized.includes('deficiency');
  }

  private getNormalizedApplicationId(): string | null {
    const rawApplicationId = this.getApplicationId();
    if (rawApplicationId === undefined || rawApplicationId === null || rawApplicationId === '') {
      return null;
    }

    let parsed = rawApplicationId;
    if (typeof parsed === 'string') {
      const trimmed = parsed.trim();
      if (!trimmed) {
        return null;
      }
      try {
        parsed = JSON.parse(trimmed);
      } catch {
        parsed = trimmed;
      }
    }

    const normalized = String(parsed).trim().replace(/^"+|"+$/g, '');
    return normalized || null;
  }

  private triggerNameChangeResubmissionStatusUpdate(): void {
    if (this.isNameChangeResubmitStatusUpdateInProgress) {
      return;
    }

    if (!this.isApplicantDuplicateRole()) {
      return;
    }

    if (!this.isNameChangePersonalInfoResubmissionContext()) {
      return;
    }

    const applicationId = this.getNormalizedApplicationId();
    if (!applicationId) {
      return;
    }

    this.isNameChangeResubmitStatusUpdateInProgress = true;
    this.resolveBackofficePendingStatusKeyAndUpdate(applicationId);
  }

  private resolveBackofficePendingStatusKeyAndUpdate(applicationId: string): void {
    if (this.backofficePendingStatusKey) {
      this.updateApplicationStatusToBackofficePending(applicationId, this.backofficePendingStatusKey);
      return;
    }

    this.httpService.get('/domain/lookup?requestType=APPLICATION_STATUS')
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          this.backofficePendingStatusKey = this.getBackofficePendingStatusKey(response);
          this.updateApplicationStatusToBackofficePending(applicationId, this.backofficePendingStatusKey);
        },
        error: (error: any) => {
          console.error('Failed to load application status lookup for Backoffice Pending update.', error);
          this.backofficePendingStatusKey = this.backofficePendingFallbackKey;
          this.updateApplicationStatusToBackofficePending(applicationId, this.backofficePendingStatusKey);
        }
      });
  }

  private updateApplicationStatusToBackofficePending(applicationId: string, statusKey: string): void {
    const payload = {
      application_id: applicationId,
      cd_application_status: statusKey
    };

    this.myAppService.updateApplicationStatus(payload)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.success === false) {
            console.warn('Backoffice Pending status update returned an unsuccessful response.', response);
            return;
          }
          this.applyBackofficePendingStatusLocally(statusKey);
        },
        error: (error: any) => {
          console.error('Failed to update Name Change resubmission status to Backoffice Pending.', error);
          this.isNameChangeResubmitStatusUpdateInProgress = false;
        },
        complete: () => {
          this.isNameChangeResubmitStatusUpdateInProgress = false;
        }
      });
  }

  private getBackofficePendingStatusKey(response: any): string {
    const statusList = Array.isArray(response?.data)
      ? response.data
      : Array.isArray(response?.data?.data)
        ? response.data.data
        : [];

    const match = statusList.find((item: any) =>
      String(item?.value || '').trim().toLowerCase() === 'backoffice pending'
    );

    return String(match?.key || this.backofficePendingFallbackKey);
  }

  private applyBackofficePendingStatusLocally(statusKey: string): void {
    const statusLabel = 'Backoffice Pending';
    this.applicationStatus = statusLabel;

    if (this.formData?.data) {
      this.formData.data.application_status = statusLabel;
      this.formData.data.cd_application_status = statusKey;
    }

    this.sessionStorage.setItem('applicationStatus', JSON.stringify(statusLabel));
    const navigationData = this.getSessionObject('navigationData');
    if (navigationData && typeof navigationData === 'object') {
      const updatedNavigationData = { ...navigationData };
      if (!updatedNavigationData.bannerheader || typeof updatedNavigationData.bannerheader !== 'object') {
        updatedNavigationData.bannerheader = {};
      }
      updatedNavigationData.bannerheader['Application Status'] = statusLabel;
      this.sessionStorage.setObj('navigationData', updatedNavigationData);
    }
  }

  private clearNextButtonStateSyncTimers(): void {
    this.nextButtonStateSyncTimers.forEach((timerId: number) => window.clearTimeout(timerId));
    this.nextButtonStateSyncTimers = [];
  }

  private updateNextButtonState(): void {
    // Guard: if the user has navigated to a different page, this component instance is stale.
    // Re-enable buttons so the stale instance doesn't block the new page, then bail out.
    const currentTitle = this.getSessionTitle();
    if (this.initialSessionTitle && currentTitle && currentTitle !== this.initialSessionTitle) {
      console.log('[updateNextButtonState] Page context changed (was:', this.initialSessionTitle, ', now:', currentTitle, '). Re-enabling buttons and skipping.');
      this.clearNextButtonStateSyncTimers();
      setTimeout(() => this.applyNextButtonState(false), 0);
      return;
    }
    const pendingUploads = this.hasPendingRequiredUploads();
    const pendingReview = this.hasPendingReviewDecisionDocuments();
    const profDevIncomplete = this.hasProfessionalDevelopmentIncompleteFields();
    const shouldDisable = pendingUploads || pendingReview || profDevIncomplete;
    setTimeout(() => this.applyNextButtonState(shouldDisable), 0);
  }

  private hasProfessionalDevelopmentIncompleteFields(): boolean {
    if (this.getSessionTitle() !== 'Professional-Development') {
      return false;
    }

    // If form fields have not been loaded yet, disable the button
    if (!this.profDevFormFieldsLoaded) {
      return true;
    }

    // Check if any of the required Professional-Development form fields are incomplete
    // Use raw values which preserve null/undefined state
    const isDistrictCharterEmpty = this.isFieldEmptyOrUndefined(this.rawDistrictCharterEmployed);
    const isAdditionalProfEmpty = this.isFieldEmptyOrUndefined(this.rawAdditionalProfCompleted);
    const isCollegeCourseworkEmpty = this.isFieldEmptyOrUndefined(this.rawCollegeUnivCoursework);

    // Only check credits earned if college coursework is true
    // If is_college_univ_coursework is false, no need to validate credits earned
    let isCreditsEarnedEmpty = false;
    if (this.rawCollegeUnivCoursework === true) {
      isCreditsEarnedEmpty = this.isFieldEmptyOrUndefined(this.rawCollegeUnivCreditsEarned);
    }

    // If any required field is undefined/null/empty, button should be disabled
    return isDistrictCharterEmpty || isAdditionalProfEmpty || isCollegeCourseworkEmpty || isCreditsEarnedEmpty;
  }

  private isFieldEmptyOrUndefined(value: any): boolean {
    if (value === undefined || value === null) {
      return true;
    }
    if (typeof value === 'string' && value.trim() === '') {
      return true;
    }
    return false;
  }

  private autoSelectSingleCategory(): void {
    // Auto-select category if only one option is available
    if (this.categories && this.categories.length === 1) {
      this.uploadData.category = this.categories[0].key;
      this.onCategoryChange();
    }
  }

  onCategoryChange() {
    // Reset document type when category changes
    this.uploadData.docType = '';
    this.docTypeError = '';
    this.duplicateDocTypeError = '';

    const currApplicationType = this.getCurrApplicationType();
    const sessionTitle = this.getSessionTitle();

    // Get filtered document types based on selected category
    this.filteredDocumentTypes = this.getDocumentTypesForCategory(this.uploadData.category);
    if ((!this.filteredDocumentTypes || !this.filteredDocumentTypes.length) && this.documentTypes && this.documentTypes.length) {
      // Fallback: if mapping table returns nothing, show all available types
      this.filteredDocumentTypes = [...this.documentTypes];
    }

    // Auto-set default document type for Proof of Relationship
    if (this.uploadData.category) {
      const selectedCategory = this.categories.find(cat => cat.key === this.uploadData.category);
      if (selectedCategory && selectedCategory.value === 'Proof of Relationship') {
        // Find Marriage Certificate in document types and set as default
        const marriageCertificate = this.documentTypes.find(dt => dt.value === 'Marriage Certificate');
        if (marriageCertificate) {
          this.uploadData.docType = marriageCertificate.key;
          this.onDocTypeChange();
        }
      }
    }

    this.cdr.detectChanges();
  }

  onDocTypeChange(): void {
    this.duplicateDocTypeError = '';
    if (!this.uploadData.category || !this.uploadData.docType) {
      return;
    }
  }

  private checkRequiredCategoriesForNameChange(): void {
    const currApplicationType = this.getCurrApplicationType();
    const sessionTitle = this.getSessionTitle();

    if (currApplicationType === 'Name Change' && sessionTitle === 'Personal-Info-Details-Page') {
      const requiredCategories = [
        'Proof of Photo Identification',
        'Proof of Legal Name Change'
      ];

      const uploadedCategories = [...new Set(this.documentHistory.map((doc: any) => doc.category_name))];
      const missingCategories = requiredCategories.filter(cat => !uploadedCategories.includes(cat));

      // if (missingCategories.length > 0) {
      //   this.alertService.error(
      //     `For Name Change applications, you must upload documents for both required categories: ${missingCategories.join(', ')}`
      //   );
      // } else {
      //   this.alertService.success('All required document categories have been uploaded.');
      // }
    }
  }
  showUploadModal(content: any) {
    if (!this.canUploadDocuments()) {
      this.alertService.error(this.dnqUploadMessage || 'Upload window has expired for this DNQ application.');
      return;
    }
    this.syncUploadContext();
    if (!this.categories || !this.categories.length || !this.documentTypes || !this.documentTypes.length) {
      this.loadDropdownData();
      // Ensure we have something to show while API responds
      if (!this.categories || !this.categories.length) {
        this.categories = this.getFallbackCategories();
      }
      if (!this.documentTypes || !this.documentTypes.length) {
        this.documentTypes = this.getFallbackDocTypes();
      }
      this.cdr.detectChanges();
    }

    // Clean up stale dynamic categories before showing the modal
    // so deleted district/provider names don't appear in the dropdown
    if (this.getSessionTitle() === 'Professional-Development') {
      this.cleanupStaleDynamicCategories();
    }

    console.log('DocumentUploadGrid: categories available in modal', this.categories);
    this.selectedRowForUpload = null;
    this.alertService.clear();
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch {}
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.duplicateDocTypeError = '';
    this.filteredDocumentTypes = [];

    this.autoSelectSingleCategory();

    this.openUploadModal(content);
    this.authServices.clearFormAttachments();
  }

  private openUploadModal(content: any): void {
    this.captureUploadModalInitialState();
    this.uploadModalRef = this.modalService.open(content, {
      size: 'lg',
      centered: true,
      backdrop: true,
      keyboard: true,
      windowClass: 'upload-modal-class',
      beforeDismiss: () => this.canDismissUploadModal()
    });
    this.uploadModalRef.result.finally(() => {
      this.uploadModalRef = null;
      this.skipUploadDismissGuard = false;
    });
  }

  private canDismissUploadModal(): boolean {
    if (this.skipUploadDismissGuard) {
      return true;
    }
    if (!this.hasPendingUploadChanges()) {
      return true;
    }
    this.openConfirmCancelModal();
    return false;
  }

  private hasPendingUploadChanges(): boolean {
    const hasFile = this.hasPendingUploadFile();
    const hasCategory = !!String(this.uploadData?.category || '').trim();
    const hasDocType = !!String(this.uploadData?.docType || '').trim();
    if (!this.uploadModalInitialState) {
      return hasFile || hasCategory || hasDocType;
    }
    return hasFile !== this.uploadModalInitialState.hasFile
      || String(this.uploadData?.category || '').trim() !== this.uploadModalInitialState.category
      || String(this.uploadData?.docType || '').trim() !== this.uploadModalInitialState.docType;
  }

  private captureUploadModalInitialState(): void {
    this.uploadModalInitialState = {
      category: String(this.uploadData?.category || '').trim(),
      docType: String(this.uploadData?.docType || '').trim(),
      hasFile: this.hasPendingUploadFile()
    };
  }

  private openConfirmCancelModal(): void {
    if (this.confirmCancelModalRef) {
      return;
    }
    this.confirmCancelModalRef = this.modalService.open(this.confirmCancelModel, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'add-appointment-details confirm-cancel-modal'
    });
    this.confirmCancelModalRef.result.finally(() => {
      this.confirmCancelModalRef = null;
    });
  }

  private closeUploadModalSilently(): void {
    this.skipUploadDismissGuard = true;
    if (this.uploadModalRef) {
      this.uploadModalRef.close();
      return;
    }
    this.modalService.dismissAll();
    this.skipUploadDismissGuard = false;
  }

  closeUploadPopup() {
    this.alertService.clear();
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch {}
    this.authServices.clearFormAttachments();
    this.uploadedFiles = [];
    if (this.confirmCancelModalRef) {
      this.confirmCancelModalRef.close();
      this.confirmCancelModalRef = null;
    }
    this.closeUploadModalSilently();
    this.oneFileIsRequired = false;
    this.categoryError = '';
    this.docTypeError = '';
    this.duplicateDocTypeError = '';
    this.filteredDocumentTypes = [];
    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
    this.selectedRowForUpload = null;
    this.uploadModalInitialState = null;
  }

  onUploadCancelClick(): void {
    if (this.hasPendingUploadChanges()) {
      this.openConfirmCancelModal();
    } else {
      this.closeUploadPopup();
    }
  }

  onConfirmCancelYes(): void {
    this.closeUploadPopup();
    this.alertService.success('Upload cancelled.');
  }

  onConfirmCancelNo(): void {
    if (this.confirmCancelModalRef) {
      this.confirmCancelModalRef.close();
    }
  }

  onFileUploaded(fileInfo: any) {
    if (!this.isReplaceFlow) {
      this.uploadData.file = fileInfo;
      this.oneFileIsRequired = false;
    } else {
      this.onReplaceFileUploaded(fileInfo)
    }
  }
  onFileSelected(_event: any) {
    // Placeholder to satisfy template binding; actual upload handled by onFileUploaded
  }

  private hasPendingUploadFile(): boolean {
    const file = this.uploadData?.file;
    if (!file) {
      return false;
    }
    if (Array.isArray(file)) {
      return file.some(item => this.isValidUploadFile(item));
    }
    if (Array.isArray(file?.attachmentdetails)) {
      return file.attachmentdetails.some((item: any) => this.isValidUploadFile(item));
    }
    if (Array.isArray(file?.fileInfo?.attachmentdetails)) {
      return file.fileInfo.attachmentdetails.some((item: any) => this.isValidUploadFile(item));
    }
    return this.isValidUploadFile(file);
  }

  private isValidUploadFile(file: any): boolean {
    return !!(file?.file_name || file?.name || file?.path || file?.file_hash);
  }

  onUploadSave() {
    if (!this.canUploadDocuments()) {
      this.alertService.error(this.dnqUploadMessage || 'Upload window has expired for this DNQ application.');
      return;
    }
    this.alertService.clear();
    try {
      const lingeringToasts = document.querySelectorAll('.toast-message, .alert-animate');
      lingeringToasts.forEach(el => el.parentElement?.removeChild(el));
    } catch { }

    this.docTypeError = '';
    this.duplicateDocTypeError = '';
    this.oneFileIsRequired = false;

    if (!this.selectedRowForUpload) {
      let invalid = false;
      if (!this.uploadData.category) {
        this.categoryError = 'Category is required.';
        invalid = true;
      }
      if (!this.uploadData.docType) {
        this.docTypeError = 'Document type is required.';
        invalid = true;
      }
      if (invalid) {
        this.cdr.detectChanges();
        return;
      }
    }

    this.proceedWithUpload();
  }

  private proceedWithUpload(): void {
    const allAttachments = this.collectAttachmentsFromUploadData();

    if (allAttachments.length === 0) {
      this.oneFileIsRequired = true;
      this.oneFileIsRequiredError = 'Please Upload a File to Proceed';
    }

    if (this.oneFileIsRequired) {
      return;
    }
    const personData = this.getSessionObject('personData');
    const personId = this.getPersonId(personData);
    const createdBy = this.getUploaderDisplayName(personData);

    const resolvedCategory = this.selectedRowForUpload?.cd_document_category || this.uploadData.category || '';
    const resolvedDocType = this.selectedRowForUpload?.cd_document_type || this.uploadData.docType || '';

    const isNewRow = !this.selectedRowForUpload || !this.selectedRowForUpload?.file_name;

    const duplicateAttachments = allAttachments.filter((attach: any) =>
      this.isDuplicateUpload(attach, resolvedCategory, resolvedDocType, this.selectedRowForUpload)
    );

    if (duplicateAttachments.length > 0) {
      this.logDocumentUploadError(duplicateAttachments[0]);
      const isApplicant = this.isApplicantDuplicateRole();
      if (isApplicant) {
        this.pendingDuplicateUpload = null;
        this.openDuplicateModal(this.duplicateApplicantModelTemplate);
        return;
      }
      this.pendingDuplicateUpload = {
        attachments: allAttachments,
        resolvedCategory,
        resolvedDocType,
        isNewRow
      };
      this.openDuplicateModal(this.duplicateStaffModelTemplate);
      return;
    }

    this.finishUpload({
      attachments: allAttachments,
      resolvedCategory,
      resolvedDocType,
      isNewRow
    });
  }

  private finishUpload(context: {
    attachments: any[];
    resolvedCategory: string;
    resolvedDocType: string;
    isNewRow: boolean;
  }): void {
    const archivedUploaderSnapshot = this.snapshotArchivedUploaderMetadata(this.documentHistory || []);
    const personData = this.getSessionObject('personData');
    const personId = this.getPersonId(personData);
    const createdBy = this.getUploaderDisplayName(personData);
    const createdById = this.getUploaderId(personData);
    const isStaffAdminPendingReviewUpload = this.isStaffOrAdminRole()
      && this.isReviewPhaseApplicationStatus()
      && context.isNewRow;

    const newDoc = context.attachments.map((attach: any) => {
      const resolvedDocumentId =
        attach.document_id
        ?? attach.documentId
        ?? attach.primary_id
        ?? attach.primaryId
        ?? attach.id
        ?? null;
      const resolvedPrimaryId = attach.primary_id ?? attach.primaryId ?? resolvedDocumentId ?? null;
      return ({
      ...attach,
      primary_id: resolvedPrimaryId,
      id: resolvedDocumentId,
      document_id: resolvedDocumentId,
      documentId: resolvedDocumentId,
      primary_object: attach.primary_object || attach.primaryObject || attach.field || '',
      category_id: context.resolvedCategory,
      cd_document_category: context.resolvedCategory,
      cd_document_type: context.resolvedDocType,
      document_type: context.resolvedDocType,
      status: 'Pending Review',
      created_by: createdById,
      created: createdBy,
      uploaded_by: createdBy,
      uploadedBy: createdBy,
      file_name: attach.name,
      created_date: now(),
      createdat: now(),
      person_id: personId,
      formid: attach.formid,
      is_active: true,
      application_id: this.formData.data.application_id,
      addedFromUploadModal: context.isNewRow,
      staffAdminReviewUpload: isStaffAdminPendingReviewUpload,
      staff_admin_review_upload: isStaffAdminPendingReviewUpload,
      document_origin: isStaffAdminPendingReviewUpload ? 'staff_admin_pending_review_upload' : ((attach as any).document_origin || ''),
      documentOrigin: isStaffAdminPendingReviewUpload ? 'staff_admin_pending_review_upload' : ((attach as any).documentOrigin || '')
      });
    });
    this.closeUploadModalSilently();
    if (this.selectedRowForUpload) {
      const uploaded = newDoc[0];
      // Match the exact row to avoid updating the first empty row in the same category.
      let idx = this.documentHistory.indexOf(this.selectedRowForUpload);
      if (idx === -1) {
        const selectedKey = this.selectedRowForUpload?.primary_id || this.selectedRowForUpload?.id || this.selectedRowForUpload?.document_id;
        if (selectedKey) {
          idx = this.documentHistory.findIndex(d => {
            const itemKey = (d as any).primary_id || (d as any).id || (d as any).document_id;
            return itemKey === selectedKey;
          });
        }
      }
      if (idx !== -1) {
        const updatedRow = { ...this.documentHistory[idx], ...uploaded };
        // Preserve existing primary_id if present to avoid duplicate creates
        if (!updatedRow.primary_id && this.documentHistory[idx].primary_id) {
          updatedRow.primary_id = this.documentHistory[idx].primary_id;
        }
        delete (updatedRow as any).isPlaceholder;
        this.documentHistory[idx] = updatedRow;
      } else {
        Object.assign(this.selectedRowForUpload, uploaded);
        // Ensure primary_id is preserved from selected row if it exists
        if (!this.selectedRowForUpload.primary_id && (this.selectedRowForUpload as any).primary_id) {
          this.selectedRowForUpload.primary_id = (this.selectedRowForUpload as any).primary_id;
        }
        delete (this.selectedRowForUpload as any).isPlaceholder;

        if (!this.selectedRowForUpload.created) {
          this.selectedRowForUpload.created = uploaded.created || createdBy;
        }
        if (!this.documentHistory.includes(this.selectedRowForUpload)) {
          this.documentHistory.push(this.selectedRowForUpload);
        }
      }
      this.selectedRowForUpload = null;
    } else {
      this.documentHistory = [...(this.documentHistory || []), ...newDoc];
    }

    // Remove any placeholder rows once a real document exists
    this.removePlaceholderRows();

    // Always append required dummy rows
    this.addDummyRow();
    this.addActiveDutyRow();
    this.addSpouseActiveDutyRow();
    this.restoreArchivedUploaderMetadata(archivedUploaderSnapshot);

    this.emitSupportingDocument(this.documentHistory);

    // RESET UI STATE
    this.uploadData = { file: null, category: '', docType: '' };
    this.uploadedFiles = [];
    this.cdr.detectChanges();
    this.filteredDocumentTypes = [];
    this.authServices.clearFormAttachments();
    this.checkRequiredCategoriesForNameChange();
    this.alertService.success(this.getToastMessage('T0041', 'Document uploaded successfully.'));
  }

  private openDuplicateModal(template: TemplateRef<any> | undefined): void {
    if (!template) {
      return;
    }
    this.duplicateModalRef = this.modalService.open(template, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      keyboard: false,
      windowClass: 'add-appointment-details'
    });
  }

  onDuplicateProceed(): void {
    const context = this.pendingDuplicateUpload;
    if (!context) {
      return;
    }
    if (this.duplicateModalRef) {
      this.duplicateModalRef.close();
      this.duplicateModalRef = null;
    }
    this.pendingDuplicateUpload = null;
    this.finishUpload(context);
  }

  onDuplicateCancel(modal?: any): void {
    if (modal?.close) {
      modal.close();
    }
    if (this.duplicateModalRef) {
      this.duplicateModalRef.close();
      this.duplicateModalRef = null;
    }
    this.pendingDuplicateUpload = null;
    this.closeUploadPopup();
  }

  private isApplicantDuplicateRole(): boolean {
    if (this.loginUserRoleId !== null && this.loginUserRoleId !== undefined) {
      return this.applicantDuplicateRoleIds.has(this.loginUserRoleId);
    }
    const storedRole = this.sessionStorage.getItem('role_id');
    if (storedRole !== null && storedRole !== undefined && storedRole !== '') {
      const parsed = Number(storedRole);
      if (!Number.isNaN(parsed)) {
        return this.applicantDuplicateRoleIds.has(parsed);
      }
    }
    const rawRole = sessionStorage.getItem('role_id');
    if (rawRole) {
      const parsed = Number(rawRole);
      if (!Number.isNaN(parsed)) {
        return this.applicantDuplicateRoleIds.has(parsed);
      }
    }
    return false;
  }

  private clearUploadFileOnly(): void {
    this.uploadData.file = null;
    this.oneFileIsRequired = false;
    this.authServices.clearFormAttachments();
    this.cdr.detectChanges();
  }

  private getToastMessage(code: string, fallback: string): string {
    try {
      const stored = window.localStorage.getItem('toastMessage');
      const map = stored ? JSON.parse(stored) : {};
      return map?.[code] || fallback;
    } catch {
      return fallback;
    }
  }


  private logDocumentUploadError(attachment: any): void {
    const personData = JSON.parse(this.sessionStorage.getItem('personData') || '{}');
    const personId = this.getPersonId(personData);
    const sessionTitle = this.getSessionTitle();
    const fallbackCategory = this.selectedRowForUpload?.cd_document_category || this.uploadData.category || '';
    const fallbackDocType = this.selectedRowForUpload?.cd_document_type || this.uploadData.docType || '';
    const categoryName = this.categories.find(c => c.key === fallbackCategory)?.value || fallbackCategory;
    const docTypeName = this.documentTypes.find(d => d.key === fallbackDocType)?.value || fallbackDocType;

    const auditLogData = {
      person_id: personId,
      action: 'DUPLICATE_FILE_ERROR',
      screen_name: sessionTitle || 'Document Upload Grid',
      field_name: categoryName,
      performed_by: personData.user_id,
      changes: JSON.stringify({
        error_type: 'Duplicate File',
        file_name: attachment.name,
        category: categoryName,
        document_type: docTypeName,
        error_message: 'File exists with same name, category and type',
        timestamp: new Date().toISOString()
      })
    };

    this.myAppService
      .uploadDocumentLog(auditLogData)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          console.log('Audit log created successfully:', response);
        },
        error: (error: any) => {
          console.error('Failed to create audit log:', error);
        }
      });
  }

  onRowCategoryChange(row: any, value: any): void {
    if (!row) return;
    row.cd_document_category = value;
    row.cd_document_type = '';
    this.documentHistory = [...this.documentHistory];
    this.cdr.detectChanges();
  }

  onRowTypeChange(row: any, value: any): void {
    if (!row) return;
    if (this.isRowTypeLocked(row)) {
      return;
    }
    row.cd_document_type = value;
    this.cdr.detectChanges();
  }

  openRowUpload(row: any, template: any): void {
    if (!this.canUploadDocuments()) {
      this.alertService.error(this.dnqUploadMessage || 'Upload window has expired for this DNQ application.');
      return;
    }
    this.syncUploadContext();
    this.selectedRowForUpload = row || null;

    this.uploadData = {
      file: null,
      category: '',
      docType: ''
    };
    this.duplicateDocTypeError = '';

    if (row) {
      const cat = this.categories.find(c => c.key === row.cd_document_category || c.value === row.cd_document_category);
      if (cat) {
        this.uploadData.category = cat.key;
      }
      this.filteredDocumentTypes = this.getDocumentTypesForCategory(this.uploadData.category);
      if (row.cd_document_type) {
        const dt = this.documentTypes.find(d => d.key === row.cd_document_type || d.value === row.cd_document_type);
        if (dt) {
          this.uploadData.docType = dt.key;
        }
      }
    }

    this.openUploadModal(template);
    this.authServices.clearFormAttachments();
  }

  getCategoryDisplayForRow(row: any): string {
    if (!row) return '';
    const keyOrValue = row.cd_document_category;
    if (!keyOrValue) return '';
    const cat = this.categories.find(c => c.key === keyOrValue || c.value === keyOrValue);
    return cat ? cat.value : (keyOrValue || 'Not provided');
  }

  getDocumentTypeDisplayValue(keyOrValue: string): string {
    if (!keyOrValue) return '';
    const dt = this.documentTypes.find(d => d.key === keyOrValue || d.value === keyOrValue);
    return dt ? dt.value : keyOrValue;
  }

  getDocumentTypeDisplayForRow(row: any): string {
    if (!row) return '';
    const keyOrValue = row.cd_document_type;
    if (!keyOrValue) return '';
    const dt = this.documentTypes.find(d => d.key === keyOrValue || d.value === keyOrValue);
    return dt ? dt.value : (keyOrValue || 'Not provided');
  }

  isRowTypeLocked(row: any): boolean {
    return !!row?.file_name;
  }

  // private sortDocumentHistory(): void {
  //   const toTime = (value: any): number => this.getSortTimestamp(value);

  //   this.documentHistory = [...(this.documentHistory || [])].sort((a: any, b: any) => {
  //     // Always push placeholders to the bottom
  //     if (a?.isPlaceholder && !b?.isPlaceholder) return 1;
  //     if (b?.isPlaceholder && !a?.isPlaceholder) return -1;

  //     const oa = this.getOrderValue(a);
  //     const ob = this.getOrderValue(b);
  //     if (oa !== ob) return oa - ob;

  //     const ta = toTime(a);
  //     const tb = toTime(b);
  //     if (ta !== tb) return ta - tb;

  //     // Stable-ish secondary key
  //     return String(a?.file_name || '').localeCompare(String(b?.file_name || ''));
  //   });
  // }

  private getOrderValue(row: any): number {
    if (!row || row.isPlaceholder) return Number.MAX_SAFE_INTEGER;
    const orderFields = ['display_order', 'order', 'sort_order', 'sequence', 'seq'];
    for (const key of orderFields) {
      const val = (row as any)[key];
      if (typeof val === 'number' && !Number.isNaN(val)) return val;
      if (typeof val === 'string' && val.trim() !== '' && !Number.isNaN(Number(val))) return Number(val);
    }
    return Number.MAX_SAFE_INTEGER / 2;
  }

  private getSortTimestamp(row: any): number {
    if (!row) return Number.MAX_SAFE_INTEGER;
    const candidates = [
      row.createdat,
      row.created_date,
      row.created_date_time,
      row.updatedat,
      row.created,
      row.createdDate
    ];

    for (const c of candidates) {
      if (c === undefined || c === null || c === '') continue;
      if (typeof c === 'number' && !Number.isNaN(c)) return c;
      const parsed = Date.parse(c);
      if (!Number.isNaN(parsed)) return parsed;
    }
    return Number.MAX_SAFE_INTEGER;
  }

  private applyDefaultRowOrdering(): void {
    if (!this.documentHistory || !this.documentHistory.length) {
      this.updateArchivedHistory();
      return;
    }

    const withIndex = this.documentHistory.map((row, idx) => ({ row, idx }));
    const noOrderValue = Number.MAX_SAFE_INTEGER / 2;

    withIndex.sort((a, b) => {
      const aAutoPending = this.isAutoManagedPendingRow(a.row);
      const bAutoPending = this.isAutoManagedPendingRow(b.row);
      if (aAutoPending !== bAutoPending) {
        return aAutoPending ? 1 : -1;
      }

      const oa = this.getOrderValue(a.row);
      const ob = this.getOrderValue(b.row);
      const aHasOrder = oa < noOrderValue;
      const bHasOrder = ob < noOrderValue;

      if (aHasOrder && bHasOrder && oa !== ob) {
        return oa - ob;
      }
      if (aHasOrder !== bHasOrder) {
        return aHasOrder ? -1 : 1;
      }

      return a.idx - b.idx;
    });

    this.documentHistory = withIndex.map(item => item.row);
    this.updateArchivedHistory();
  }

  private isAutoManagedPendingRow(row: any): boolean {
    if (!row) {
      return false;
    }
    const isAutoManaged = !!((row as any).keepRowOnDelete || (row as any).autoManagedCategoryRow);
    if (!isAutoManaged) {
      return false;
    }
    const hasFile = !!(row.file_name || row.path || row.file_hash);
    return !hasFile;
  }

  private normalizeCategoryKey(categoryKey: any): string {
    if (!categoryKey) return '';
    const found = this.categories?.find(c => c.key === categoryKey || c.value === categoryKey);
    return found ? String(found.key).toLowerCase() : String(categoryKey).toLowerCase();
  }

  private ensureCategoryExists(label: string, gridType?: 'districtCharter' | 'providerName'): string {
    if (!label) return '';
    const target = this.normalizeCategoryKey(label);
    const existing = (this.categories || []).find(cat => {
      const keyMatch = this.normalizeCategoryKey(cat.key) === target;
      const valueMatch = this.normalizeCategoryKey(cat.value) === target;
      return keyMatch || valueMatch;
    });
    if (existing) {
      const key = existing.key || existing.value || label;
      // Track dynamic category origin
      const wasTracked = this.dynamicDistrictCategoryKeys.has(key) || this.dynamicProviderCategoryKeys.has(key);
      if (gridType === 'districtCharter') {
        this.dynamicDistrictCategoryKeys.add(key);
      } else if (gridType === 'providerName') {
        this.dynamicProviderCategoryKeys.add(key);
      }
      // Invalidate cache if tracking changed (category was re-added after being removed)
      if (!wasTracked && gridType) {
        this.invalidateDocTypesCache();
      }
      return key;
    }
    const fallback = { key: label, value: label };
    this.categories = [...(this.categories || []), fallback];
    // Track dynamic category origin
    if (gridType === 'districtCharter') {
      this.dynamicDistrictCategoryKeys.add(fallback.key);
    } else if (gridType === 'providerName') {
      this.dynamicProviderCategoryKeys.add(fallback.key);
    }
    // Invalidate doc types cache when new category is added
    this.invalidateDocTypesCache();
    return fallback.key;
  }

  private normalizeDocTypeKey(docTypeKey: any): string {
    if (!docTypeKey) return '';
    const found = this.documentTypes?.find(d => d.key === docTypeKey || d.value === docTypeKey);
    return found ? String(found.key).toLowerCase() : String(docTypeKey).toLowerCase();
  }

  private getRowCategoryKey(row: any): string {
    if (!row) return '';
    const raw =
      row.cd_document_category
      || row.category_name
      || row.category
      || row.category_id
      || row.description
      || '';
    return this.normalizeCategoryKey(raw);
  }

  private getCategoryRowCount(categoryKey: string): number {
    if (!categoryKey) return 0;
    return (this.documentHistory || []).filter(row => {
      if (!row) return false;
      return this.getRowCategoryKey(row) === categoryKey;
    }).length;
  }

  private isRequiredCategoryKey(categoryKey: string): boolean {
    if (!categoryKey) return false;
    if (this.getSessionTitle() !== 'Personal-Info-Details-Page') {
      return false;
    }

    const required: string[] = ['Proof of Photo Identification'];
    if (this.shouldShowLegalNameChangeRow()) {
      required.push('Proof of Legal Name Change');
    }
    if (this.shouldShowProofOfServiceRow()) {
      required.push('Proof of Service');
    }
    if (this.shouldShowProofOfRelationshipRow()) {
      required.push('Proof of Relationship');
    }

    const normalizedRequired = required.map(cat => this.normalizeCategoryKey(cat));
    return normalizedRequired.includes(categoryKey);
  }

  private isRadioControlledCategoryKey(categoryKey: string): boolean {
    if (!categoryKey) return false;
    if (this.getSessionTitle() !== 'Personal-Info-Details-Page') {
      return false;
    }
    const normalizedRadio = this.defaultRowCategories
      .filter(cat => cat !== 'Proof of Photo Identification')
      .map(cat => this.normalizeCategoryKey(cat));
    return normalizedRadio.includes(categoryKey);
  }

  private isDuplicateDocType(docTypeKey: string, categoryKey: string, ignoreRow?: any): boolean {
    const normalizedType = this.normalizeDocTypeKey(docTypeKey);
    const normalizedCategory = this.normalizeCategoryKey(categoryKey);
    if (!normalizedType || !normalizedCategory) return false;

    return (this.documentHistory || []).some(row => {
      if (!row || row.isPlaceholder) return false;
      if (ignoreRow && row === ignoreRow) return false;
      if (!row.cd_document_type) return false;
      const val = this.normalizeDocTypeKey(row.cd_document_type);
      const cat = this.normalizeCategoryKey(row.cd_document_category);
      return val === normalizedType && cat === normalizedCategory;
    });
  }

  private hasExistingDocumentForType(docTypeKey: string, categoryKey: string, ignoreRow?: any): boolean {
    const normalizedType = this.normalizeDocTypeKey(docTypeKey);
    const normalizedCategory = this.normalizeCategoryKey(categoryKey);
    if (!normalizedType || !normalizedCategory) return false;

    return (this.documentHistory || []).some(row => {
      if (!this.shouldCheckDuplicateAgainstRow(row, ignoreRow)) return false;
      if (!row.cd_document_type) return false;
      const val = this.normalizeDocTypeKey(row.cd_document_type);
      const cat = this.normalizeCategoryKey(row.cd_document_category);
      if (val !== normalizedType || cat !== normalizedCategory) {
        return false;
      }
      return !!(row.file_name || row.name || row.path || row.file_hash);
    });
  }

  private shouldCheckDuplicateAgainstRow(row: any, ignoreRow?: any): boolean {
    return !!row
      && !row.isPlaceholder
      && !(ignoreRow && this.isSameDocumentRow(row, ignoreRow))
      && !this.isArchivedDocument(row)
      && !this.isDeletedDocumentRow(row);
  }

  private isDeletedDocumentRow(row: any): boolean {
    if (!row) {
      return false;
    }
    const status = String(row.status || row.document_status || row.documentStatus || '').trim().toLowerCase();
    return status === 'deleted';
  }

  private isSameDocumentRow(left: any, right: any): boolean {
    if (!left || !right) {
      return false;
    }

    const leftKey = left.primary_id || left.document_id || left.id;
    const rightKey = right.primary_id || right.document_id || right.id;
    if (leftKey && rightKey) {
      return String(leftKey) === String(rightKey);
    }

    const leftFile = String(left.file_name || left.name || '').trim().toLowerCase();
    const rightFile = String(right.file_name || right.name || '').trim().toLowerCase();
    if (!leftFile || leftFile !== rightFile) {
      return false;
    }

    const leftPath = String(left.path || left.file_hash || '').trim().toLowerCase();
    const rightPath = String(right.path || right.file_hash || '').trim().toLowerCase();
    const samePath = !!(leftPath && rightPath && leftPath === rightPath);
    if (samePath) {
      return true;
    }

    const leftCategory = this.normalizeCategoryKey(left.category_id || left.cd_document_category);
    const rightCategory = this.normalizeCategoryKey(right.category_id || right.cd_document_category);
    const leftType = this.normalizeDocTypeKey(left.cd_document_type || left.document_type);
    const rightType = this.normalizeDocTypeKey(right.cd_document_type || right.document_type);
    return !!(leftCategory && rightCategory && leftType && rightType
      && leftCategory === rightCategory
      && leftType === rightType);
  }

  canSaveUpload(): boolean {
    if (!this.canUploadDocuments()) {
      return false;
    }
    if (this.selectedRowForUpload) {
      return true;
    }
    if (!this.uploadData.category || !this.uploadData.docType) {
      return false;
    }
    return true;
  }

  private collectAttachmentsFromUploadData(): any[] {
    const attachments: any[] = [];
    const formData = this.uploadData || {};
    const defaultFormId = this.getEffectiveFormId();

    const pushAttachment = (file: any, field: string, meta: any = {}) => {
      if (!file) return;
      const name = file.file_name || file.name;
      const rawPath = file.path || file.file_hash;
      if (!name || !rawPath) return;
      const resolvedDocumentId =
        file.document_id
        ?? file.documentId
        ?? file.primary_id
        ?? file.primaryId
        ?? file.id
        ?? meta.document_id
        ?? meta.documentId
        ?? null;
      const resolvedPrimaryId = file.primary_id ?? file.primaryId ?? resolvedDocumentId ?? null;
      attachments.push({
        ...file,
        name,
        file_name: file.file_name || name,
        file_hash: file.file_hash || rawPath,
        path: rawPath,
        attachmenttype: file.attachmenttype || file.type || 'application/octet-stream',
        field: file.field || field,
        formid: file.formid ?? meta.formid ?? defaultFormId,
        pageId: file.pageId ?? meta.pageId ?? meta.pageid,
        id: resolvedDocumentId,
        document_id: resolvedDocumentId,
        documentId: resolvedDocumentId,
        primary_id: resolvedPrimaryId,
        primaryId: resolvedPrimaryId,
        type: file.type ?? meta.type
      });
    };

    Object.entries(formData).forEach(([field, value]: [string, any]) => {
      if (!value) return;
      const meta = {
        field,
        formid: value?.formid,
        pageId: value?.pageId,
        pageid: value?.pageid,
        id: value?.id,
        document_id: value?.document_id,
        documentId: value?.documentId,
        type: value?.type
      };
      if (Array.isArray(value?.attachmentdetails) && value.attachmentdetails.length > 0) {
        value.attachmentdetails.forEach((file: any) => pushAttachment(file, field, meta));
        return;
      }
      if (typeof value === 'object') {
        pushAttachment(value, field, meta);
      }
    });

    return attachments;
  }

  private getPersonId(personData?: any): any {
    try {
      const pd = personData || JSON.parse(sessionStorage.getItem('personData') || '{}');
      return pd?.person_id
        || this.formData?.data?.person_id
        || this.formData?.data?.personId
        || this.formData?.data?.applicantId
        || '';
    } catch {
      return '';
    }
  }

  private getSessionObject(key: string): any {
    const raw = this.sessionStorage.getItem(key);
    if (!raw) return {};
    if (typeof raw === 'object') return raw;
    try {
      return JSON.parse(raw);
    } catch {
      return {};
    }
  }

  private buildDisplayName(source: any): string {
    if (!source) return '';
    const first = source.first_name || source.firstname || '';
    const middle = source.middle_name || source.middlename || '';
    const last = source.last_name || source.lastname || '';
    const full = [first, middle, last].filter(Boolean).join(' ').trim();
    if (full) return full;
    return source.full_name || source.name || source.username || source.user_name || '';
  }

  private getUploaderId(personData?: any): string {
    const user = this.getSessionObject('user');
    const pd = personData || this.getSessionObject('personData');
    const id =
      user?.user_id ||
      user?.id ||
      pd?.user_id ||
      pd?.id ||
      this.sessionStorage.getItem('id') ||
      '';
    return id ? String(id) : '';
  }

  private getUploaderDisplayName(personData?: any): string {
    const user = this.getSessionObject('user');
    const userName = this.buildDisplayName(user);
    if (userName) return userName;

    const pd = personData || this.getSessionObject('personData');
    const personName = this.buildDisplayName(pd);
    if (personName) return personName;

    const sessionUsername = this.sessionStorage.getItem('username');
    if (sessionUsername) return String(sessionUsername);

    const fallbackId = this.getUploaderId(pd);
    return fallbackId || 'Unknown';
  }

  private getApplicationId(): any {
    return this.formData?.data?.application_id
      || sessionStorage.getItem('applicationID')
      || sessionStorage.getItem('applicationId')
      || '';
  }

  private isDnqStatus(status: any): boolean {
    if (!status) return false;
    const normalized = String(status).trim();
    if (doesNotQualify.some(rule => rule.appStatus === normalized)) {
      return true;
    }
    const lower = normalized.toLowerCase();
    return lower.includes('dnq') || lower.includes('does not qualify') || lower.includes('denied') || lower.includes('partially approved');
  }

  private parseDnqDate(value: any): Date | null {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'number' && !Number.isNaN(value)) {
      return new Date(value);
    }
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (/^\d+$/.test(trimmed)) {
        const millis = Number(trimmed);
        if (!Number.isNaN(millis)) return new Date(millis);
      }
      const parsed = Date.parse(trimmed);
      if (!Number.isNaN(parsed)) return new Date(parsed);
    }
    return null;
  }

  private resolveDnqDueDate(item: any): Date | null {
    if (!item) return null;
    const due = this.parseDnqDate(item.dnq_due_date);
    if (due) return due;
    const statusDate = this.parseDnqDate(item.status_date);
    if (!statusDate) return null;
    const computed = new Date(statusDate.getTime());
    computed.setDate(computed.getDate() + 45);
    return computed;
  }

  private updateDnqUploadAllowed(): void {
    if (!this.isDnqStatus(this.applicationStatus)) {
      this.dnqUploadAllowed = true;
      this.dnqUploadMessage = '';
      return;
    }
    if (!this.dnqUploadDeadline) {
      this.dnqUploadAllowed = true;
      this.dnqUploadMessage = '';
      return;
    }
    const now = new Date();
    this.dnqUploadAllowed = now <= this.dnqUploadDeadline;
    if (this.dnqUploadAllowed) {
      this.dnqUploadMessage = '';
    } else {
      const formatted = this.dnqUploadDeadline.toLocaleDateString('en-US');
      this.dnqUploadMessage = `DNQ response period ended on ${formatted}. Uploads are no longer allowed.`;
    }
  }

  private evaluateDnqUploadWindow(): void {
    if (!this.isDnqStatus(this.applicationStatus)) {
      this.dnqUploadAllowed = true;
      this.dnqUploadMessage = '';
      return;
    }
    const personId = this.getPersonId();
    if (!personId) {
      this.dnqUploadAllowed = true;
      this.dnqUploadMessage = '';
      return;
    }
    if (this.dnqUploadChecked && this.dnqUploadPersonId === personId) {
      this.updateDnqUploadAllowed();
      return;
    }
    this.dnqUploadChecked = true;
    this.dnqUploadPersonId = personId;
    this.httpService
      .get(`/application-flow/license-kind-endorsements?personId=${personId}`)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const rows = res?.data?.data?.data
            || res?.data?.data
            || res?.data
            || [];
          const appId = this.getApplicationId();
          let item = null;
          if (appId && Array.isArray(rows)) {
            item = rows.find((r: any) => String(r?.application_id) === String(appId));
          }
          if (!item && Array.isArray(rows)) {
            item = rows[0];
          }
          this.dnqUploadDeadline = this.resolveDnqDueDate(item);
          this.updateDnqUploadAllowed();
        },
        error: () => {
          this.dnqUploadAllowed = true;
          this.dnqUploadMessage = '';
        }
      });
  }

  canUploadDocuments(): boolean {
    if (!this.isDnqStatus(this.applicationStatus)) {
      return true;
    }
    return this.dnqUploadAllowed;
  }

  checkReadOnlyMode(): void {
    if (this.readOnlyCondition) {
      try {
        const readOnlyScript = this.readOnlyCondition.replace(/sessionStorage/g, 'sessionStorageService');
        const prefix = 'var readOnlyCondition = false;';
        const suffix = ';return { readOnlyCondition: readOnlyCondition };';
        const fnDef = new Function('data', 'sessionStorageService', `${prefix}${readOnlyScript}${suffix}`);
        const result = fnDef(this.formData?.data || {}, this.sessionStorage);
        this.readOnlyMode = result.readOnlyCondition;
      } catch (e) {
        console.error('Error evaluating read only condition:', e);
        this.readOnlyMode = false;
      }
    } else {
      this.readOnlyMode = false;
    }
  }

  private normalizeBoolean(value: any): boolean {
    if (value === true || value === false) {
      return value;
    }
    if (typeof value === 'string') {
      const normalized = value.trim().toLowerCase();
      return normalized === 'yes' || normalized === 'true' || normalized === '1';
    }
    if (typeof value === 'number') {
      return value === 1;
    }
    return false;
  }

  private normalizeOptionalBoolean(value: any): boolean | null {
    if (value === undefined || value === null || value === '') {
      return null;
    }
    return this.normalizeBoolean(value);
  }

  private getLegalNameChangeRecordCount(data: any): number {
    const rows = this.extractPriorNameRows(data);
    if (!rows.length) {
      return 0;
    }
    const activeRows = rows.filter(row => !this.isPriorNameRowDeleted(row));
    if (!activeRows.length) {
      return 0;
    }
    const populatedRows = activeRows.filter(row => this.isPriorNameRowPopulated(row));
    return populatedRows.length;
  }

  private extractPriorNameRows(data: any): any[] {
    if (!data) {
      return [];
    }
    const payload = Array.isArray(data) ? data[0] : data;
    const payloadRows = this.extractPriorNameRowsFromPayload(payload);
    const changeRows = this.getPriorNamesFromChange();

    if (payloadRows.length) {
      return changeRows.length > payloadRows.length ? changeRows : payloadRows;
    }

    if (changeRows.length) {
      return changeRows;
    }

    return [];
  }

  private extractPriorNameRowsFromPayload(payload: any): any[] {
    if (!payload) {
      return [];
    }
    const nameHistoryRaw = payload?.pf_name_history;
    const nameHistory = Array.isArray(nameHistoryRaw) ? nameHistoryRaw[0] : nameHistoryRaw;
    const candidates: { value: any; trust: boolean }[] = [
      { value: payload?.pf_prior_names, trust: true },
      { value: payload?.prior_names, trust: true },
      { value: payload?.priorNames, trust: true },
      { value: payload?.prior_name_history, trust: true },
      { value: payload?.personalInformation?.pf_prior_names, trust: true },
      { value: payload?.personalInformation?.prior_names, trust: true },
      { value: payload?.personalInformation?.priorNames, trust: true },
      { value: payload?.personal_information?.pf_prior_names, trust: true },
      { value: payload?.personal_information?.prior_names, trust: true },
      { value: payload?.personal_information?.priorNames, trust: true },
      { value: nameHistory?.pf_prior_names, trust: true },
      { value: nameHistory?.prior_names, trust: true },
      { value: nameHistory?.priorNames, trust: true }
    ];

    for (const candidate of candidates) {
      if (candidate.value === undefined || candidate.value === null) {
        continue;
      }
      const flattened = this.flattenRowArray(this.unwrapRowCandidate(candidate.value));
      const rows = candidate.trust ? flattened : this.filterPriorNameRows(flattened);
      if (rows.length) {
        return rows;
      }
    }

    const deepMatch = this.findPriorNameRowsDeep(payload);
    if (deepMatch.length) {
      return deepMatch;
    }

    return [];
  }

  private unwrapRowCandidate(candidate: any): any {
    if (!candidate || typeof candidate !== 'object') {
      return candidate;
    }
    if (Array.isArray(candidate)) {
      return candidate;
    }
    if (Array.isArray((candidate as any).data)) {
      return (candidate as any).data;
    }
    if (Array.isArray((candidate as any).rows)) {
      return (candidate as any).rows;
    }
    if (Array.isArray((candidate as any).value)) {
      return (candidate as any).value;
    }
    const arrayCandidates: { key: string; value: any[] }[] = [];
    Object.keys(candidate).forEach(key => {
      const value = (candidate as any)[key];
      if (Array.isArray(value)) {
        arrayCandidates.push({ key, value });
        return;
      }
      if (value && typeof value === 'object') {
        if (Array.isArray((value as any).data)) {
          arrayCandidates.push({ key, value: (value as any).data });
          return;
        }
        if (Array.isArray((value as any).rows)) {
          arrayCandidates.push({ key, value: (value as any).rows });
          return;
        }
        if (Array.isArray((value as any).value)) {
          arrayCandidates.push({ key, value: (value as any).value });
          return;
        }
      }
    });
    if (arrayCandidates.length) {
      const preferred = arrayCandidates.find(c => this.isPriorNamesKey(c.key));
      if (preferred) {
        return preferred.value;
      }
      if (arrayCandidates.length === 1) {
        return arrayCandidates[0].value;
      }
      const nonEmpty = arrayCandidates.find(c => c.value && c.value.length);
      if (nonEmpty) {
        return nonEmpty.value;
      }
    }
    return candidate;
  }

  private flattenRowArray(value: any): any[] {
    if (!Array.isArray(value)) {
      if (value && typeof value === 'object') {
        return [value];
      }
      return [];
    }
    const result: any[] = [];
    const stack = [...value];
    while (stack.length) {
      const item = stack.shift();
      if (Array.isArray(item)) {
        stack.unshift(...item);
      } else if (item !== null && item !== undefined) {
        result.push(item);
      }
    }
    return result;
  }

  private getPriorNamesFromChange(): any[] {
    const change = this.lastFormioChange;
    if (!change) {
      return [];
    }
    const key = String(
      change?.component?.key
      || change?.component?.path
      || change?.component?.label
      || ''
    ).toLowerCase();
    if (!key) {
      return [];
    }
    if (
      !key.includes('prior')
      && !key.includes('name_history')
      && !key.includes('namehistory')
      && !key.includes('legalname')
    ) {
      return [];
    }
    let value = change?.value ?? change?.data ?? change?.component?.dataValue;
    const componentKey = String(change?.component?.key || change?.component?.path || '').trim();
    if (componentKey && value && typeof value === 'object' && !Array.isArray(value)) {
      const direct = (value as any)[componentKey];
      if (direct !== undefined) {
        value = direct;
      }
    }
    return this.flattenRowArray(this.unwrapRowCandidate(value));
  }

  private isPriorNamesKey(key: string): boolean {
    const normalized = String(key || '').toLowerCase();
    return normalized.includes('prior')
      || normalized.includes('name_history')
      || normalized.includes('namehistory')
      || normalized.includes('legalname')
      || normalized.includes('legal_name');
  }

  private findPriorNameRowsDeep(payload: any): any[] {
    const matches: any[] = [];
    const visited = new Set<any>();
    const walk = (node: any) => {
      if (!node || typeof node !== 'object') {
        return;
      }
      if (visited.has(node)) {
        return;
      }
      visited.add(node);
      if (Array.isArray(node)) {
        const flattened = this.filterPriorNameRows(this.flattenRowArray(node));
        if (flattened.length) {
          matches.push(flattened);
        }
        node.forEach(item => walk(item));
        return;
      }
      Object.values(node).forEach(value => walk(value));
    };
    walk(payload);
    if (!matches.length) {
      return [];
    }
    matches.sort((a, b) => b.length - a.length);
    return matches[0];
  }

  private filterPriorNameRows(rows: any[]): any[] {
    if (!rows.length) {
      return [];
    }
    return rows.filter(row => this.hasPriorNameKeys(row) || this.isPriorNameRowPopulated(row));
  }

  private hasPriorNameKeys(row: any): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }
    const explicitKeys = [
      'prior_first_name',
      'prior_middle_name',
      'prior_last_name',
      'cd_suffix',
      'priorfirstname',
      'priormiddlename',
      'priorlastname',
      'priorfn',
      'priormn',
      'priorln',
      'suffix',
      'priorsuffix'
    ];
    const explicitSet = new Set(explicitKeys);
    const normalizedKeys = Object.keys(row).map(key => String(key).toLowerCase());
    if (normalizedKeys.some(key => explicitSet.has(key))) {
      return true;
    }
    const hasPriorish = normalizedKeys.some(key =>
      key.includes('prior')
      || key.includes('previous')
      || key.includes('former')
      || key.includes('maiden')
      || key.includes('old')
    );
    if (hasPriorish) {
      return true;
    }
    const hasFirst = normalizedKeys.some(key => key.includes('first'));
    const hasLast = normalizedKeys.some(key => key.includes('last'));
    const hasMiddle = normalizedKeys.some(key => key.includes('middle'));
    const hasSuffix = normalizedKeys.some(key => key.includes('suffix'));
    return hasFirst && hasLast && (hasMiddle || hasSuffix);
  }

  private isPriorNameRowPopulated(row: any): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }
    if (!this.hasPriorNameKeys(row)) {
      return false;
    }
    if (this.isPriorNameRowDeleted(row)) {
      return false;
    }
    const keys = [
      'prior_first_name',
      'prior_middle_name',
      'prior_last_name',
      'cd_suffix',
      'priorFirstName',
      'priorMiddleName',
      'priorLastName',
      'priorFN',
      'priorMN',
      'priorLN',
      'suffix',
      'priorSuffix'
    ];
    for (const key of keys) {
      const value = (row as any)[key];
      if (typeof value === 'string' && value.trim() !== '') {
        return true;
      }
      if (value !== null && value !== undefined && value !== '' && typeof value !== 'string') {
        return true;
      }
    }

    const ignored = new Set([
      'id',
      '_id',
      'rowId',
      'index',
      'created',
      'createdat',
      'created_at',
      'updated',
      'updatedat',
      'updated_at',
      'created_by',
      'updated_by'
    ]);
    const isNameRelatedKey = (key: string): boolean => {
      const normalized = String(key || '').toLowerCase();
      return normalized.includes('first')
        || normalized.includes('middle')
        || normalized.includes('last')
        || normalized.includes('suffix')
        || normalized.includes('prior')
        || normalized.includes('name');
    };
    return Object.keys(row).some(key => {
      if (ignored.has(key)) {
        return false;
      }
      if (!isNameRelatedKey(key)) {
        return false;
      }
      if (this.isDeleteFlagKey(key) && this.normalizeBoolean((row as any)[key])) {
        return false;
      }
      const value = (row as any)[key];
      if (value === null || value === undefined) {
        return false;
      }
      if (typeof value === 'string') {
        return value.trim() !== '';
      }
      if (typeof value === 'boolean') {
        return value === true;
      }
      if (typeof value === 'number') {
        return !Number.isNaN(value);
      }
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      if (typeof value === 'object') {
        return Object.keys(value).length > 0;
      }
      return false;
    });
  }

  private isPriorNameRowDeleted(row: any): boolean {
    if (!row || typeof row !== 'object') {
      return false;
    }
    return Object.keys(row).some(key => {
      if (!this.isDeleteFlagKey(key)) {
        return false;
      }
      return this.normalizeBoolean((row as any)[key]);
    });
  }

  private isDeleteFlagKey(key: string): boolean {
    const normalized = String(key || '').toLowerCase();
    return normalized === 'isdeleted'
      || normalized === 'is_deleted'
      || normalized === 'deleted'
      || normalized === '_deleted'
      || normalized === 'isdelete'
      || normalized === 'is_delete'
      || normalized === 'remove'
      || normalized === '_remove';
  }

  private addDummyRow(): void {
    const sessionTitle = this.getSessionTitle();

    if (sessionTitle === 'Professional-Development') {
      this.addProfessionalDevelopmentDummyRows();
      return;
    }

    if (sessionTitle !== 'Personal-Info-Details-Page') {
      return;
    }

    if (!this.categories || !this.categories.length) {
      return;
    }

    const photoIdCategory = this.categories.find(cat => cat.value === 'Proof of Photo Identification');
    if (!photoIdCategory) {
      return;
    }

    const hasRealPhotoIdRow = (this.documentHistory || []).some(row =>
      (row.cd_document_category === photoIdCategory.key || row.cd_document_category === photoIdCategory.value) &&
      !(row as any).isPlaceholder
    );
    if (hasRealPhotoIdRow) {
      return;
    }

    if ((this.documentHistory || []).some(row => (row as any).isPlaceholder)) {
      return;
    }

    const dummyRow = {
      cd_document_type: '',
      cd_document_category: photoIdCategory.key,
      file_name: '',
      status: '',
      createdat: null,
      created: '',
      isPlaceholder: true
    };

    this.documentHistory = [...this.documentHistory, dummyRow];
    this.applyDefaultRowOrdering();
    this.updateNextButtonState();
  }

  private addProfessionalDevelopmentDummyRows(): void {
    // This method is now controlled by form values - just call sync
    this.syncProfessionalDevelopmentRows();
  }

  /**
   * Hydrate tracking sets from document history for documents that were loaded from API.
   * This is needed because documents from API don't have profDevGridType set,
   * and the tracking sets are only populated when ensureCategoryExists is called.
   * By hydrating from history, we can identify dynamic categories even when the
   * corresponding grid item has been removed.
   */
  private hydrateProfDevTrackingFromHistory(): void {
    if (!this.documentHistory || !this.documentHistory.length) {
      return;
    }

    // Get set of standard category keys (from API domain lookup)
    const standardCategoryKeys = new Set(
      (this.categories || [])
        .filter((c: any) => {
          const val = String(c.value || '').trim();
          // Standard categories are those that were loaded from domain lookup
          // and are not dynamically added district/provider names
          return val && !this.dynamicDistrictCategoryKeys.has(c.key) && !this.dynamicProviderCategoryKeys.has(c.key);
        })
        .map((c: any) => c.key)
    );

    // Check each document history row
    this.documentHistory.forEach((row: any) => {
      if (!row.cd_document_category) {
        return;
      }

      const categoryKey = row.cd_document_category;

      // If already in tracking sets or is a standard category, skip
      if (this.dynamicDistrictCategoryKeys.has(categoryKey) ||
          this.dynamicProviderCategoryKeys.has(categoryKey) ||
          standardCategoryKeys.has(categoryKey)) {
        return;
      }

      // If row has profDevGridType set, add to appropriate tracking set
      if (row.profDevGridType === 'districtCharter') {
        this.dynamicDistrictCategoryKeys.add(categoryKey);
        return;
      }
      if (row.profDevGridType === 'providerName') {
        this.dynamicProviderCategoryKeys.add(categoryKey);
        return;
      }

      // Check if the category looks like a non-standard category
      // (not in standard categories and not obviously a standard doc type)
      const isStandardLookingCategory = this.isStandardDocumentCategory(categoryKey);
      if (!isStandardLookingCategory) {
        // This is likely a dynamic category - try to determine type
        // For now, add to district tracking if it's not identifiable
        // This is a fallback and will be cleaned up if not in current grid data
        this.dynamicDistrictCategoryKeys.add(categoryKey);
      }
    });
  }

  /**
   * Check if a category key looks like a standard document category.
   * Standard categories are predefined ones like "Proof of Photo Identification".
   */
  private isStandardDocumentCategory(categoryKey: string): boolean {
    if (!categoryKey) return false;

    const standardPatterns = [
      'proof of',
      'arl certificate',
      'apprentice letter',
      'testing score report',
      'history disclosure',
      'out-of-state licensure'
    ];

    const normalized = categoryKey.toLowerCase();
    return standardPatterns.some(pattern => normalized.includes(pattern));
  }

  private syncProfessionalDevelopmentRows(): void {
    if (this.getSessionTitle() !== 'Professional-Development') {
      return;
    }

    // Hydrate tracking sets from document history FIRST
    // This ensures documents loaded from API are properly tracked
    this.hydrateProfDevTrackingFromHistory();

    // Handle District / Charter School Name - only show when flag is true AND grid data has items
    if (this.isDistrictCharterEmployed && this.districtGridData && this.districtGridData.length > 0) {
      this.addDistrictCharterRow();
    } else {
      this.removeDistrictCharterRow();
    }

    // Handle Provider Name - only show when flag is true AND grid data has items
    if (this.isAdditionalProfCompleted && this.addProfDevelopmentData && this.addProfDevelopmentData.length > 0) {
      this.addProviderNameRow();
    } else {
      this.removeProviderNameRow();
    }

    // Clean up stale dynamic categories that no longer have corresponding grid items
    this.cleanupStaleDynamicCategories();

    // Ensure uploadDocumentHistory is always in sync after row changes
    this.updateArchivedHistory();
    this.updateNextButtonState();
    this.cdr.detectChanges();
  }

  private addDistrictCharterRow(): void {
    if (!this.categories || !this.categories.length) {
      return;
    }

    // Only add rows if we have districtGridData with items
    if (!this.districtGridData || this.districtGridData.length === 0) {
      return;
    }

    // FIRST: Populate tracking sets for ALL current grid items before cleanup
    // This ensures the tracking sets are populated before cleanup runs
    this.districtGridData.forEach((gridItem: any) => {
      const categoryName = gridItem?.district_charter_name_text;
      if (categoryName) {
        this.ensureCategoryExists(categoryName, 'districtCharter');
      }
    });

    // THEN: Clean up rows for grid items that no longer exist
    this.cleanupRemovedDistrictCharterRows();

    // FINALLY: Create placeholder rows for current grid items that don't have rows yet
    this.districtGridData.forEach((gridItem: any) => {
      const categoryName = gridItem?.district_charter_name_text;
      if (!categoryName) {
        return;
      }

      // Get the category key (already ensured to exist above)
      const categoryKey = this.ensureCategoryExists(categoryName, 'districtCharter');

      // Check if row already exists for this specific category
      const hasExistingRow = (this.documentHistory || []).some(row =>
        row.cd_document_category === categoryKey || row.cd_document_category === categoryName
      );
      if (hasExistingRow) {
        return;
      }

      const newRow = {
        cd_document_type: '',
        cd_document_category: categoryKey,
        file_name: '',
        status: '',
        createdat: null,
        created: '',
        isPlaceholder: true,
        autoManagedCategoryRow: true,
        profDevGridType: 'districtCharter',
        profDevGridItemId: gridItem?.primary_id || gridItem?.id
      };

      this.documentHistory = [...(this.documentHistory || []), newRow];
    });
    this.applyDefaultRowOrdering();
    this.cdr.detectChanges();
  }

  private cleanupRemovedDistrictCharterRows(): void {
    // Get current district names from grid data
    const currentDistrictNames = new Set(
      (this.districtGridData || []).map((item: any) => item?.district_charter_name_text).filter(Boolean)
    );

    // Filter out rows that are district charter type but no longer in grid data
    this.documentHistory = (this.documentHistory || []).filter((row: any) => {
      const categoryKey = row.cd_document_category;
      const isDistrictCharterByType = (row as any).profDevGridType === 'districtCharter';
      const isDistrictCharterByCategory = this.dynamicDistrictCategoryKeys.has(categoryKey);

      // If it's not a districtCharter row, keep it
      if (!isDistrictCharterByType && !isDistrictCharterByCategory) {
        return true;
      }
      // Keep if it has a file uploaded (don't remove uploaded documents)
      if (row.file_name) {
        return true;
      }
      // Check if the category still exists in current grid data
      return currentDistrictNames.has(categoryKey);
    });
  }

  private removeDistrictCharterRow(): void {
    // Remove all dynamic district charter rows (only placeholders without files)
    this.documentHistory = (this.documentHistory || []).filter((row: any) => {
      const categoryKey = row.cd_document_category;
      const isDistrictByType = (row as any).profDevGridType === 'districtCharter';
      const isDistrictByCategory = this.dynamicDistrictCategoryKeys.has(categoryKey);

      // If it's not a district charter row (by either type or tracking set), keep it
      if (!isDistrictByType && !isDistrictByCategory) {
        return true;
      }
      // Keep if it has a file uploaded
      if (row.file_name) {
        return true;
      }
      return false; // Remove placeholder district charter rows
    });
    // Also remove generic category if any
    this.removeCategoryRows('District / Charter School Name', { removeAll: true });
    // Ensure the grid data source is refreshed in real-time
    this.updateArchivedHistory();
    this.cdr.detectChanges();
  }

  private addProviderNameRow(): void {
    if (!this.categories || !this.categories.length) {
      return;
    }

    // Only add rows if we have addProfDevelopmentData with items
    if (!this.addProfDevelopmentData || this.addProfDevelopmentData.length === 0) {
      return;
    }

    // FIRST: Populate tracking sets for ALL current grid items before cleanup
    // This ensures the tracking sets are populated before cleanup runs
    this.addProfDevelopmentData.forEach((gridItem: any) => {
      const categoryName = gridItem?.provider_name_text;
      if (categoryName) {
        this.ensureCategoryExists(categoryName, 'providerName');
      }
    });

    // THEN: Clean up rows for grid items that no longer exist
    this.cleanupRemovedProviderNameRows();

    // FINALLY: Create placeholder rows for current grid items that don't have rows yet
    this.addProfDevelopmentData.forEach((gridItem: any) => {
      const categoryName = gridItem?.provider_name_text;
      if (!categoryName) {
        return;
      }

      // Get the category key (already ensured to exist above)
      const categoryKey = this.ensureCategoryExists(categoryName, 'providerName');

      // Check if row already exists for this specific category
      const hasExistingRow = (this.documentHistory || []).some(row =>
        row.cd_document_category === categoryKey || row.cd_document_category === categoryName
      );
      if (hasExistingRow) {
        return;
      }

      const newRow = {
        cd_document_type: '',
        cd_document_category: categoryKey,
        file_name: '',
        status: '',
        createdat: null,
        created: '',
        isPlaceholder: true,
        autoManagedCategoryRow: true,
        profDevGridType: 'providerName',
        profDevGridItemId: gridItem?.primary_id || gridItem?.id
      };

      this.documentHistory = [...(this.documentHistory || []), newRow];
    });
    this.applyDefaultRowOrdering();
    this.cdr.detectChanges();
  }

  private cleanupRemovedProviderNameRows(): void {
    // Get current provider names from grid data
    const currentProviderNames = new Set(
      (this.addProfDevelopmentData || []).map((item: any) => item?.provider_name_text).filter(Boolean)
    );

    // Filter out rows that are provider name type but no longer in grid data
    this.documentHistory = (this.documentHistory || []).filter((row: any) => {
      const categoryKey = row.cd_document_category;
      const isProviderByType = (row as any).profDevGridType === 'providerName';
      const isProviderByCategory = this.dynamicProviderCategoryKeys.has(categoryKey);

      // If it's not a provider name row, keep it
      if (!isProviderByType && !isProviderByCategory) {
        return true;
      }
      // Keep if it has a file uploaded (don't remove uploaded documents)
      if (row.file_name) {
        return true;
      }
      // Check if the category still exists in current grid data
      return currentProviderNames.has(categoryKey);
    });
  }

  private removeProviderNameRow(): void {
    // Remove all dynamic provider rows (only placeholders without files)
    this.documentHistory = (this.documentHistory || []).filter((row: any) => {
      const categoryKey = row.cd_document_category;
      const isProviderByType = (row as any).profDevGridType === 'providerName';
      const isProviderByCategory = this.dynamicProviderCategoryKeys.has(categoryKey);

      // If it's not a provider row (by either type or tracking set), keep it
      if (!isProviderByType && !isProviderByCategory) {
        return true;
      }
      // Keep if it has a file uploaded
      if (row.file_name) {
        return true;
      }
      return false; // Remove placeholder provider name rows
    });
    // Also remove generic category if any
    this.removeCategoryRows('Provider Name', { removeAll: true });
    // Ensure the grid data source is refreshed in real-time
    this.updateArchivedHistory();
    this.cdr.detectChanges();
  }

  private ensureLegalNameChangeRows(requiredCount: number): void {
    const categoryKey = this.ensureCategoryExists('Proof of Legal Name Change');
    if (!categoryKey) {
      return;
    }

    const normalized = this.normalizeCategoryKey(categoryKey);
    const rows = this.documentHistory || [];
    const rowsForCategory = rows.filter(row =>
      this.normalizeCategoryKey(row?.cd_document_category) === normalized
    );
    const existingCount = rowsForCategory.length;

    if (existingCount < requiredCount) {
      const toAdd = requiredCount - existingCount;
      const newRows = Array.from({ length: toAdd }, () => ({
        cd_document_type: '',
        cd_document_category: categoryKey,
        file_name: '',
        status: '',
        createdat: null,
        created: '',
        keepRowOnDelete: true,
        autoManagedCategoryRow: true
      }));
      this.documentHistory = [...rows, ...newRows];
      this.applyDefaultRowOrdering();
      this.cdr.detectChanges();
      this.updateNextButtonState();
      return;
    }

    if (existingCount > requiredCount) {
      const nonRemovable = rowsForCategory.filter(row => !this.isLegalNameChangeRowRemovable(row));
      const targetCount = Math.max(requiredCount, nonRemovable.length);
      if (existingCount <= targetCount) {
        return;
      }
      const removable = rowsForCategory.filter(row => this.isLegalNameChangeRowRemovable(row));
      const toRemove = Math.min(existingCount - targetCount, removable.length);
      if (!toRemove) {
        return;
      }
      const removeSet = new Set(removable.slice(-toRemove));
      this.documentHistory = rows.filter(row => !removeSet.has(row));
      this.applyDefaultRowOrdering();
      this.cdr.detectChanges();
      this.updateNextButtonState();
    }
  }

  private isLegalNameChangeRowRemovable(row: any): boolean {
    if (!row) {
      return false;
    }
    if (row.isPlaceholder) {
      return true;
    }
    const hasFile = !!(row.file_name || row.path || row.file_hash);
    if (hasFile) {
      return false;
    }
    const hasId = !!(row.primary_id || row.document_id || row.id);
    return !hasId;
  }

  private removeCategoryRows(categoryValue: string, options: { removeAll?: boolean } = {}): void {
    if (!this.documentHistory || !this.documentHistory.length) {
      return;
    }

    const removeAll = options.removeAll === true;
    const normalizedTarget = this.normalizeCategoryKey(categoryValue);
    const filtered = (this.documentHistory || []).filter(row => {
      if (this.getRowCategoryKey(row) !== normalizedTarget) {
        return true;
      }
      if (removeAll) {
        return false;
      }
      const isAutoManagedRemovable = this.isAutoManagedCategoryRowRemovable(row);
      return !isAutoManagedRemovable;
    });

    if (filtered.length === this.documentHistory.length) {
      return;
    }

    this.documentHistory = filtered;
    this.applyDefaultRowOrdering();
    this.clearSelections();
    this.emitSupportingDocument(this.documentHistory);
    this.cdr.detectChanges();
  }

  private isAutoManagedCategoryRowRemovable(row: any): boolean {
    if (!row) {
      return false;
    }
    const isAutoManaged = !!((row as any)?.keepRowOnDelete || (row as any)?.autoManagedCategoryRow);
    if (!isAutoManaged) {
      return false;
    }
    const hasFile = !!(row.file_name || row.path || row.file_hash);
    if (hasFile) {
      return false;
    }
    const hasId = !!(row.primary_id || row.document_id || row.id);
    return !hasId;
  }

  private removeLegalNameChangeRow(): void {
    this.removeCategoryRows('Proof of Legal Name Change');
  }

  private addActiveDutyRow(): void {
    if (!this.shouldShowProofOfServiceRow()) {
      return;
    }

    // Find the key for "Proof of Service"
    const proofOfServiceCategory = this.categories.find(cat => cat.value === 'Proof of Service');
    if (!proofOfServiceCategory) {
      return;
    }

    const rowsForCategory = (this.documentHistory || []).filter(row =>
      row.cd_document_category === proofOfServiceCategory.key || row.cd_document_category === proofOfServiceCategory.value
    );
    if (rowsForCategory.length) {
      return;
    }

    const activeDutyRow = {
      cd_document_type: '',
      cd_document_category: proofOfServiceCategory.key,
      file_name: '',
      status: '',
      createdat: null,
      created: '',
      keepRowOnDelete: true,
      autoManagedCategoryRow: true
    };

    this.documentHistory = [...this.documentHistory, activeDutyRow];
    this.applyDefaultRowOrdering();
    this.cdr.detectChanges();
    this.updateNextButtonState();
  }

  private removeActiveDutyRow(): void {
    if (this.shouldShowProofOfServiceRow()) {
      return;
    }
    this.removeCategoryRows('Proof of Service', { removeAll: true });
  }

  private shouldShowProofOfServiceRow(): boolean {
    return this.isOnActiveDuty === true
      || this.isVeteranDefinition === true
      || this.isSpouseOnActiveDuty === true
      || this.isSpouseVeteran === true;
  }

  private isDuplicateUpload(attachment: any, categoryKey: string, docTypeKey: string, ignoreRow?: any): boolean {
    const fileName = String(attachment?.file_name || attachment?.name || '').trim().toLowerCase();
    if (!fileName) {
      return false;
    }
    const normalizedCategory = this.normalizeCategoryKey(categoryKey);
    const normalizedDocType = this.normalizeDocTypeKey(docTypeKey);

    return (this.documentHistory || []).some((existing: any) => {
      if (!this.shouldCheckDuplicateAgainstRow(existing, ignoreRow)) {
        return false;
      }
      const existingName = String(existing?.file_name || existing?.name || '').trim().toLowerCase();
      if (!existingName || existingName !== fileName) {
        return false;
      }
      const existingCategory = this.normalizeCategoryKey(existing?.category_id || existing?.cd_document_category);
      if (existingCategory !== normalizedCategory) {
        return false;
      }
      const existingDocType = this.normalizeDocTypeKey(existing?.cd_document_type || existing?.document_type);
      const hasAnyDocType = !!(normalizedDocType || existingDocType);
      if (!hasAnyDocType) {
        return true;
      }
      return existingDocType === normalizedDocType;
    });
  }

  private addSpouseActiveDutyRow(): void {
    if (!this.shouldShowProofOfRelationshipRow()) {
      return;
    }

    const proofOfRelationshipCategory = this.categories.find(cat => cat.value === 'Proof of Relationship');
    if (!proofOfRelationshipCategory) {
      return;
    }
    const defaultDocType = this.getDefaultDocTypeKeyForCategory(proofOfRelationshipCategory.key);

    const rowsForCategory = (this.documentHistory || []).filter(row =>
      row.cd_document_category === proofOfRelationshipCategory.key || row.cd_document_category === proofOfRelationshipCategory.value
    );
    if (rowsForCategory.length) {
      return;
    }

    const spouseActiveDutyRow = {
      cd_document_type: defaultDocType,
      cd_document_category: proofOfRelationshipCategory.key,
      file_name: '',
      status: '',
      createdat: null,
      created: '',
      keepRowOnDelete: true,
      autoManagedCategoryRow: true
    };

    this.documentHistory = [...this.documentHistory, spouseActiveDutyRow];
    this.applyDefaultRowOrdering();
    this.cdr.detectChanges();
    this.updateNextButtonState();
  }

  private removeSpouseActiveDutyRow(): void {
    if (this.shouldShowProofOfRelationshipRow()) {
      return;
    }
    this.removeCategoryRows('Proof of Relationship', { removeAll: true });
  }

  private shouldShowProofOfRelationshipRow(): boolean {
    return this.isSpouseOnActiveDuty === true || this.isSpouseVeteran === true;
  }

  private getDefaultDocTypeKeyForCategory(categoryKey: string): string {
    if (!categoryKey) {
      return '';
    }
    const types = this.getDocumentTypesForCategory(categoryKey);
    if (types.length === 1) {
      return types[0].key;
    }
    const category = this.categories.find(cat => cat.key === categoryKey || cat.value === categoryKey);
    if (category?.value === 'Proof of Relationship') {
      const marriageCertificate = this.documentTypes.find(dt => dt.value === 'Marriage Certificate');
      return marriageCertificate?.key || '';
    }
    return '';
  }

  getLegalChangeEventValue(event: any) {
    const needsLegalNameChange = event === 'yes' || event === true;
    this.needsLegalNameChange = needsLegalNameChange;
    this.syncLegalNameChangeRow();
  }

  onActiveDutyChange(event: any): void {
    this.manualActiveDutySet = true;
    this.isOnActiveDuty = event === 'yes' || event === true;
    this.refreshVeteranRows();
  }

  onVeteranDefinitionChange(event: any): void {
    this.manualVeteranDefinitionSet = true;
    this.isVeteranDefinition = event === 'yes' || event === true;
    this.refreshVeteranRows();
  }

  onSpouseActiveDutyChange(event: any): void {
    this.manualSpouseActiveDutySet = true;
    this.isSpouseOnActiveDuty = event === 'yes' || event === true;
    this.refreshVeteranRows();
  }

  onSpouseVeteranChange(event: any): void {
    this.manualSpouseVeteranSet = true;
    this.isSpouseVeteran = event === 'yes' || event === true;
    this.refreshVeteranRows();
  }

  private refreshVeteranRows(): void {
    if (this.shouldShowProofOfServiceRow()) {
      this.addActiveDutyRow();
    } else {
      this.removeActiveDutyRow();
    }

    if (this.shouldShowProofOfRelationshipRow()) {
      this.addSpouseActiveDutyRow();
    } else {
      this.removeSpouseActiveDutyRow();
    }
  }


 showCustomAction() {
    if(this.formData?.data?.documentsActionIcon && Object.keys(this.formData?.data?.documentsActionIcon).length > 0){
       this.isShowView = this.formData?.data?.documentsActionIcon?.isShowView;
       this.isShowDownload = this.formData?.data?.documentsActionIcon?.isShowDownload;
       this.isShowDelete = this.formData?.data?.documentsActionIcon?.isShowDelete;
       this.isShowReplaceFile = this.formData?.data?.documentsActionIcon?.isShowReplaceFile;

     } else {
       // Default action icons when not configured in form
       this.isShowView = true;
       this.isShowDownload = true;
       this.isShowDelete = true;
     }
    this.applyDocumentValidationActionRules();
    this.applyApplicantActionRules();
    this.updateNextButtonState();
   }

  private applyDocumentValidationActionRules(): void {
    const hasIntakeAccess = this.hasIntakeRoleAccess();
    this.isShowMarkAsValid = hasIntakeAccess;
    this.isShowMarkAsDificient = hasIntakeAccess;
  }

  private hasIntakeRoleAccess(): boolean {
    const roleId = this.getCurrentRoleId();
    if (!roleId) {
      return false;
    }
    return roleId === ROLE_ID.NDE_Reviewer
      || roleId === ROLE_ID.Licensing_Technician
      || roleId === ROLE_ID.Licensing_LeadTechnician;
  }

  private getCurrentRoleId(): number | null {
    if (this.loginUserRoleId !== null && this.loginUserRoleId !== undefined && !Number.isNaN(this.loginUserRoleId)) {
      return this.loginUserRoleId;
    }
    const rawRoleId = this.sessionStorage.getItem('role_id') ?? sessionStorage.getItem('role_id');
    if (rawRoleId === null || rawRoleId === undefined || rawRoleId === '') {
      return null;
    }
    const normalized = String(rawRoleId).trim().replace(/^['"]|['"]$/g, '');
    if (!normalized) {
      return null;
    }
    const parsed = Number(normalized);
    return Number.isNaN(parsed) ? null : parsed;
  }

  private applyApplicantActionRules(): void {
    if (!this.isApplicantDuplicateRole()) {
      return;
    }
    this.isShowReplaceFile = true;
  }

  onRowPrepared(e: any): void {
    if (!e || e.rowType !== 'data') {
      return;
    }
    const shouldHighlight = this.shouldHighlightDeficientRow(e.data);
    const rowElement = (e.rowElement?.classList ? e.rowElement : e.rowElement?.[0]) as HTMLElement | undefined;
    if (!rowElement?.classList) {
      return;
    }

    rowElement.classList.toggle('deficient-row', shouldHighlight);
    const cells = Array.from(rowElement.querySelectorAll('td'));
    cells.forEach((cell: Element, index: number) => {
      const element = cell as HTMLElement;
      element.classList.toggle('deficient-cell', shouldHighlight);
      if (shouldHighlight) {
        element.style.setProperty('background', 'var(--deficient-row-bg-color)', 'important');
        element.style.setProperty('background-color', 'var(--deficient-row-bg-color)', 'important');
        element.style.setProperty('background-image', 'none', 'important');
        element.style.setProperty('border-top-color', 'var(--deficient-row-border-color)', 'important');
        element.style.setProperty('border-bottom-color', 'var(--deficient-row-border-color)', 'important');
        if (index === 0) {
          element.style.setProperty('box-shadow', 'inset 4px 0 0 var(--deficient-row-accent-color)', 'important');
        }
      } else {
        element.style.removeProperty('background');
        element.style.removeProperty('background-color');
        element.style.removeProperty('background-image');
        element.style.removeProperty('border-top-color');
        element.style.removeProperty('border-bottom-color');
        if (index === 0) {
          element.style.removeProperty('box-shadow');
        }
      }
    });
  }

  private shouldHighlightDeficientRow(row: any): boolean {
    const status = String(row?.status || row?.document_status || row?.documentStatus || '').trim().toLowerCase();
    return status === 'deficient' || status === 'replaced';
  }

   onUpload(event, upload) {
    let resID = '';
    if (this.responseId) {
      resID = `/${this.responseId}`;
    }
    let data: FileUpload;
    event.files.map(f => {
      data = {
        fileName: `${this.pageId}${resID}/${f.name}`,
        contentType: f.type,
        type: this.formStatus
      };
      this.pageBuilderAddService.getUploadKey(data).subscribe((res: any) => {
        const url = res.data;
        const uploadDetails = f;
        const type = f.type;
        const fileURL = res.data;
        this.uploadedFiles = [
          {
            name: f.name,
            path: fileURL,
            attachmenttype: f.type
          }
        ];
        const fileInfo: FileUploadInfo = {
          type: this.formStatus,
          formid: Number(this.pageId),
          attachmentdetails: this.uploadedFiles
        };
        this.httpService.putUpload(url, uploadDetails, type).subscribe(() => {
          this.alertService.success('Document Uploaded Successfully!');
          this.isShow = true;
          console.log(this.uploadedFiles);
          this.value = fileInfo;
          this.valueChange.emit(fileInfo);
          this.onFileUploaded(fileInfo);
          upload.clear();
        });
        this.authService.setSharedMessage(fileInfo);
      });
    });
  }

  deleteAttachment(e) {
    this.isShow = false;
    const file = e;
    if (file?.id) {
      this.pageBuilderAddService.deleteFormResponseAttachment(file.id).subscribe(() => {
        this.alertService.success('Deleted successfully!');
      });
    } else {
      this.uploadedFiles = [];
    }
  }

  viewAttachment(file: any, isDownload: boolean = false) {
    if (!file.path) return;
    const payload = { fileName: file.path };
    if (!file.path.startsWith('http')) {
      this.pageBuilderAddService.downloadFormResponseAttachment(payload).pipe(
        takeUntil(this.destroy$),
        catchError(err => {
          this.alertService.error('Failed to retrieve file.');
          throw err;
        })
      ).subscribe((response: any) => {
        this.handleFileUrl({ path: response.data, name: file.name }, isDownload);
      });
    } else {
      this.handleFileUrl(file, isDownload);
    }
  }

  handleFileUrl(file, isDownload) {
    if (!isDownload) {
      const newWin = window.open(file.path, '_blank', 'noopener');
      if (newWin) newWin.opener = null;
      return;
    }
    this.http.get(file.path, { responseType: 'blob' })
      .pipe(
        takeUntil(this.destroy$),
        catchError((err) => {
         this.alertService.error('Failed to download file.');
         throw err;
        })
      )
      .subscribe((response: any) => {
        const url = window.URL.createObjectURL(response);
        const a = document.createElement('a');
        a.href = url;
        a.download = file.name || 'downloaded-file';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      });
  }


  handleFileUploadError(event: any) {
    const file = event?.files?.[0];
    const maxBytes = this.maxFileSize ?? this.maxUploadFileSizeBytes;
    const isFileSizeError = !!(file && maxBytes && Number(file.size) > Number(maxBytes));
    this.fileUploadError = isFileSizeError
      ? this.fileSizeExceededMessage
      : this.fileTypeNotSupportedMessage;
  }

  private get EDU_STATIC_CATEGORIES(): string[] {
    const cats = ['High School Diploma or Equivalent'];
    if (!this.isLicensePathRestricted()) {
      cats.push(this.EDU_CAT_ARL);
      if (!this.isProviderTraditional()) {
        cats.push(this.EDU_CAT_PROOF);
      }
    }
    return cats;
  }

  private syncEducationInformationRows(): void {
    if (this.getSessionTitle() !== 'Education-Information') {
      return;
    }

    this.eduSyncInProgress = true;
    try {
      for (const catName of this.EDU_STATIC_CATEGORIES) {
        const catKey = this.ensureCategoryExists(catName);
        const hasRow = (this.documentHistory || []).some(row =>
          row.cd_document_category === catKey || row.cd_document_category === catName
        );
        if (!hasRow) {
          this.documentHistory = [...(this.documentHistory || []), {
            cd_document_type: '',
            cd_document_category: catKey,
            file_name: '',
            status: '',
            createdat: null,
            created: '',
            isPlaceholder: true,
            autoManagedCategoryRow: true,
            eduGridType: 'static'
          }];
        }
      }

      if (this.isNevadaTestingEnabled && this.nevadaTestingGridData && this.nevadaTestingGridData.length > 0) {
        this.addTestingRows(this.nevadaTestingGridData, 'Nevada Testing Score Report', this.EDU_GRID_TYPE_NEVADA);
      } else {
        this.removeTestingRows(this.EDU_GRID_TYPE_NEVADA);
      }

      if (this.isOutOfStateTestingEnabled && this.outOfStateTestingGridData && this.outOfStateTestingGridData.length > 0) {
        this.addTestingRows(this.outOfStateTestingGridData, 'Out-of-State Testing Score Report', this.EDU_GRID_TYPE_OUT_OF_STATE);
      } else {
        this.removeTestingRows(this.EDU_GRID_TYPE_OUT_OF_STATE);
      }

      this.applyDefaultRowOrdering();
    } catch (err) {
      console.error('syncEducationInformationRows error', err);
    } finally {
      this.eduSyncInProgress = false;
    }

    this.updateNextButtonState();
    setTimeout(() => {
      if (!this.eduSyncInProgress) {
        this.cdr.detectChanges();
      }
    });
  }

  private addTestingRows(gridData: any[], categoryLabel: string, gridType: string): void {
    if (!gridData || gridData.length === 0) {
      return;
    }

    const categoryKey = this.ensureCategoryExists(categoryLabel);
    this.cleanupRemovedTestingRows(gridData, gridType);

    const existingIds = new Set(
      (this.documentHistory || [])
        .filter((row: any) => (row as any).eduGridType === gridType)
        .map((row: any) => (row as any).eduGridItemId)
    );

    const newRows = gridData
      .filter((gridItem: any) => {
        const testName = gridItem?.test_name;
        const itemId = gridItem?.primary_id || gridItem?.id;
        return testName && !existingIds.has(itemId);
      })
      .map((gridItem: any) => ({
        cd_document_type: gridItem.test_name,
        cd_document_category: categoryKey,
        file_name: '',
        status: '',
        createdat: null,
        created: '',
        isPlaceholder: true,
        autoManagedCategoryRow: true,
        eduGridType: gridType,
        eduGridItemId: gridItem?.primary_id || gridItem?.id
      }));

    if (newRows.length) {
      this.documentHistory = [...(this.documentHistory || []), ...newRows];
    }
  }

  private cleanupRemovedTestingRows(gridData: any[], gridType: string): void {
    const currentIds = new Set(
      (gridData || []).map((item: any) => item?.primary_id || item?.id).filter(Boolean)
    );
    this.documentHistory = (this.documentHistory || []).filter((row: any) => {
      if ((row as any).eduGridType !== gridType) {
        return true;
      }
      if (row.file_name) {
        return true;
      }
      return currentIds.has((row as any).eduGridItemId);
    });
  }

  private removeTestingRows(gridType: string): void {
    this.documentHistory = (this.documentHistory || []).filter((row: any) => {
      if ((row as any).eduGridType !== gridType) {
        return true;
      }
      return !!row.file_name;
    });
  }
}
